{
  "_meta": {
    "_comment": "Phase 6 Wave 2 Task 06 — Vietnamese (primary). vg-binding: PLAN:task-06 / P6.D-131 / P6.D-221",
    "locale": "vi",
    "completeness": "primary"
  },
  "app": {
    "name": "Printway Merchant"
  },
  "actions": {
    "save": "Lưu",
    "cancel": "Hủy",
    "delete": "Xóa",
    "confirm": "Xác nhận",
    "back": "Quay lại",
    "submit": "Gửi",
    "edit": "Sửa",
    "create": "Tạo mới",
    "search": "Tìm kiếm",
    "filter": "Lọc",
    "refresh": "Làm mới",
    "loading": "Đang tải…",
    "processing": "Đang xử lý…",
    "retry": "Thử lại",
    "logout": "Đăng xuất",
    "login": "Đăng nhập",
    "copy": "Sao chép",
    "copied": "Đã sao chép",
    "clear": "Xóa lọc",
    "previous": "Trước",
    "next": "Sau",
    "close": "Đóng",
    "dismiss": "Bỏ qua",
    "fullscreen": "Toàn màn hình",
    "remove": "Xoá",
    "collapse": "Thu gọn",
    "confirmDelete": "Xoá \"{{name}}\"? Hành động này không thể hoàn tác.",
    "continue": "Tiếp tục",
    "done": "Xong",
    "expand": "Mở rộng",
    "menu": "Menu",
    "prev": "Trước",
    "saveChanges": "Lưu thay đổi",
    "saved": "Đã lưu",
    "saving": "Đang lưu…",
    "select": "Chọn…",
    "setDefault": "Đặt làm mặc định",
    "unsetDefault": "Bỏ mặc định",
    "upToDate": "Đã cập nhật",
    "upload": "Tải lên",
    "label": "Thao tác",
    "enable": "Bật"
  },
  "navigation": {
    "dashboard": "Tổng quan",
    "stores": "Cửa hàng",
    "products": "Sản phẩm",
    "orders": "Đơn hàng",
    "shipments": "Theo dõi vận chuyển",
    "wallet": "Ví",
    "invoices": "Hóa đơn",
    "notifications": "Thông báo",
    "support": "Hỗ trợ",
    "tickets": "Tickets",
    "settings": "Cài đặt",
    "finance": "Tài chính",
    "team": "Đội ngũ",
    "members": "Thành viên",
    "teams": "Nhóm",
    "branding": "Thương hiệu",
    "sidebar": {
      "catalog": "Danh mục",
      "myProducts": "Sản phẩm của tôi",
      "storeSettings": "Cài đặt cửa hàng",
      "syncLogs": "Nhật ký đồng bộ",
      "billing": "Thanh toán",
      "profile": "Hồ sơ",
      "settingsTeam": "Đội ngũ",
      "settingsNotifications": "Thông báo",
      "loginHistory": "Lịch sử đăng nhập"
    }
  },
  "topbar": {
    "selectLanguage": "Chọn ngôn ngữ",
    "selectTimezone": "Chọn múi giờ",
    "profile": "Hồ sơ",
    "theme": {
      "label": "Giao diện",
      "light": "Sáng",
      "dark": "Tối",
      "system": "Theo hệ thống"
    },
    "balance": {
      "label": "Số dư"
    },
    "outstanding": {
      "label": "Còn nợ",
      "overdueBadge_one": "{{count}} quá hạn",
      "overdueBadge_other": "{{count}} quá hạn",
      "overdueBadge": "{{count}} quá hạn"
    },
    "help": {
      "label": "Trợ giúp",
      "support": "Hỗ trợ / Trung tâm trợ giúp",
      "contact": "Liên hệ hỗ trợ",
      "documentation": "Tài liệu",
      "email": "Gửi email cho chúng tôi"
    },
    "announcement": {
      "viewDetails": "Xem chi tiết thông báo",
      "dismiss": "Bỏ qua",
      "previous": "Trước",
      "next": "Tiếp"
    },
    "emailNotVerified": "Email chưa xác minh",
    "emailNotVerifiedAria": "Email chưa xác minh — mở hồ sơ để gửi lại email xác minh",
    "walletBalance": "Ví",
    "walletBalanceAria": "Số dư ví {{label}}",
    "notifications": {
      "title": "Thông báo",
      "ariaWithCount": "Thông báo ({{count}} chưa đọc)",
      "unreadCount": "{{count}} chưa đọc",
      "loading": "Đang tải…",
      "empty": "Chưa có thông báo nào.",
      "viewAll": "Xem tất cả",
      "markAllRead": "Đánh dấu tất cả đã đọc",
      "markReadError": "Không thể đánh dấu đã đọc. Vui lòng thử lại.",
      "reloadPrompt": "Đã có phiên bản mới — vui lòng làm mới trình duyệt.",
      "forbidden": {
        "title": "Không khả dụng thông báo",
        "body": "Bạn hiện không có quyền truy cập nguồn thông báo.",
        "retry": "Thử lại"
      }
    },
    "invoices": {
      "overdue": "Hóa đơn quá hạn",
      "dueSoon": "Hóa đơn sắp đến hạn",
      "outstandingAria": "Hóa đơn chưa thanh toán {{label}}"
    },
    "logoAria": "Trang chủ Printway"
  },
  "banners": {
    "_comment": "Phase 6 Wave 12 Task 42 — Persistent banner copy (suspend + overdue invoice). vg-binding: PLAN:task-42 / P6.D-114 / P6.D-247 / P6.D-248 / G-70 / G-71",
    "suspend": {
      "title": "Tài khoản tạm ngưng",
      "message": "Tài khoản của bạn đang bị tạm ngưng. Liên hệ Admin Support để khôi phục.",
      "contact": "Liên hệ Support"
    },
    "overdue": {
      "title_one": "{{count}} hoá đơn quá hạn",
      "title_other": "{{count}} hoá đơn quá hạn",
      "cta": "Thanh toán ngay",
      "dismiss": "Đóng"
    }
  },
  "mutationGuard": {
    "_comment": "Phase 6 Wave 12 Task 42 — Mutation lockdown copy. vg-binding: PLAN:task-42 / P6.D-114 / P6.D-248",
    "disabled": "Hành động bị vô hiệu — tài khoản tạm ngưng",
    "error": "Không thể thực hiện thao tác này khi tài khoản tạm ngưng"
  },
  "suspended": {
    "title": "Tài khoản bị tạm ngưng",
    "body": "Vui lòng liên hệ Support để được hỗ trợ.",
    "shortLabel": "Tạm ngưng — liên hệ Support."
  },
  "auth": {
    "_comment": "Phase 6 Wave 12 Task 43 — adds forgotPassword + resetPassword sub-namespaces. vg-binding: PLAN:task-43 / P6.D-184 / P6.D-130",
    "title": "Đăng nhập để tiếp tục",
    "email": "Email",
    "password": "Mật khẩu",
    "remember": "Ghi nhớ đăng nhập",
    "forgot": "Quên mật khẩu?",
    "submit": "Đăng nhập",
    "submitting": "Đang xử lý…",
    "twofa": {
      "prompt": "Mở ứng dụng xác thực và nhập mã 6 chữ số.",
      "label": "Mã xác thực (TOTP)",
      "submit": "Xác nhận"
    },
    "errors": {
      "invalidEmail": "Email không hợp lệ.",
      "missingEmail": "Vui lòng nhập email.",
      "missingPassword": "Vui lòng nhập mật khẩu.",
      "shortPassword": "Mật khẩu tối thiểu 8 ký tự.",
      "invalidTotp": "Mã TOTP gồm 6 chữ số.",
      "invalidCredentials": "Email hoặc mật khẩu không đúng.",
      "accountLockedTitle": "Tài khoản tạm khóa.",
      "accountLockedBody": "5 lần nhập sai liên tiếp — vui lòng thử lại sau {{countdown}} hoặc đặt lại mật khẩu qua email.",
      "rateLimited": "Bạn thao tác quá nhanh. Vui lòng thử lại sau ít phút.",
      "network": "Không thể kết nối đến máy chủ. Vui lòng thử lại."
    },
    "forgotPassword": {
      "title": "Quên mật khẩu",
      "subtitle": "Nhập email tài khoản — chúng tôi sẽ gửi đường dẫn đặt lại mật khẩu.",
      "email": "Email",
      "submit": "Gửi email đặt lại",
      "backToLogin": "← Quay lại đăng nhập",
      "sentSuccess": {
        "title": "Email đã gửi (nếu hợp lệ)",
        "message": "Nếu email tồn tại, chúng tôi đã gửi liên kết khôi phục.",
        "hint": "Không thấy mail? Kiểm tra hộp thư rác (spam), hoặc email có thể chưa đăng ký — bạn có thể tạo tài khoản mới."
      },
      "headingFull": "Quên mật khẩu?",
      "helperFull": "Nhập email của bạn, chúng tôi sẽ gửi hướng dẫn đặt lại mật khẩu.",
      "login": "Đăng nhập",
      "remember": "Nhớ mật khẩu rồi?",
      "submitFull": "Gửi hướng dẫn đặt lại",
      "submittingFull": "Đang gửi…"
    },
    "resetPassword": {
      "title": "Đặt lại mật khẩu",
      "subtitle": "Nhập mật khẩu mới cho tài khoản của bạn.",
      "newPassword": "Mật khẩu mới",
      "confirmPassword": "Xác nhận mật khẩu mới",
      "submit": "Đặt lại mật khẩu",
      "success": "Mật khẩu đã được đặt lại. Đang chuyển về đăng nhập…",
      "tokenInvalid": "Liên kết đặt lại đã hết hạn hoặc không hợp lệ. Vui lòng yêu cầu liên kết mới.",
      "requestNew": "→ Yêu cầu liên kết mới"
    },
    "footnote": "Phiên đăng nhập được bảo vệ bằng cookie an toàn.",
    "login": {
      "_comment": "Phase 6 i18n batch M1 — Marketing decor panel on LoginPage right column. vg-binding: P6.D-131 / P6.D-221",
      "marketing": {
        "workspaceBadge": "Workspace Merchant",
        "ordersTitle": "Đơn hàng hôm nay",
        "live": "Trực tuyến",
        "orders": "Đơn hàng",
        "onTime": "Đúng hạn",
        "wallet": "Ví",
        "syncQueue": "Hàng đợi đồng bộ",
        "productsReady": "{{count}} sản phẩm sẵn sàng",
        "billing": "Hoá đơn",
        "billingClear": "Sạch nợ",
        "noOverdue": "Không có hoá đơn quá hạn"
      },
      "heading": "Chào mừng trở lại",
      "noAccount": "Mới biết đến Printway?",
      "submit": "Đăng nhập",
      "submitting": "Đang đăng nhập…"
    },
    "register": {
      "_comment": "Phase 6 i18n batch M1 — RegisterPage country select options + existing register sub-keys. vg-binding: P6.D-131 / P6.D-221 / P6.D-253",
      "countries": {
        "VN": "Việt Nam (VN)",
        "US": "Hoa Kỳ (US)",
        "GB": "Vương quốc Anh (GB)",
        "AU": "Úc (AU)",
        "CA": "Canada (CA)",
        "FR": "Pháp (FR)",
        "DE": "Đức (DE)"
      },
      "countryLabel": "Quốc gia",
      "email": "Email",
      "errors": {
        "emailRequired": "Vui lòng nhập email hợp lệ.",
        "passwordTooShort": "Mật khẩu phải có tối thiểu 12 ký tự.",
        "displayNameRequired": "Vui lòng nhập tên hiển thị.",
        "countryRequired": "Vui lòng chọn quốc gia.",
        "acceptTermsRequired": "Bạn cần đồng ý với điều khoản dịch vụ.",
        "emailTaken": "Email đã được đăng ký. Đăng nhập thay vì đăng ký mới.",
        "invalid": "Vui lòng kiểm tra lại thông tin.",
        "rateLimit": "Quá nhiều yêu cầu. Thử lại sau ít phút.",
        "generic": "Đăng ký thất bại. Vui lòng thử lại.",
        "passwordMismatch": "Mật khẩu nhập lại không khớp."
      },
      "title": "Tạo tài khoản",
      "subtitle": "Đăng ký để bắt đầu bán sản phẩm in theo yêu cầu trên Printway.",
      "password": "Mật khẩu",
      "displayName": "Tên hiển thị",
      "acceptTerms": "Tôi đồng ý với điều khoản dịch vụ và chính sách bảo mật.",
      "submit": "Đăng ký",
      "alreadyHaveAccount": "Đã có tài khoản?",
      "loginLink": "Đăng nhập",
      "passwordHint": "(tối thiểu 12 ký tự)",
      "confirmPassword": "Nhập lại mật khẩu"
    },
    "emailPlaceholder": "your@email.com",
    "marketing": {
      "subtitle": "Tham gia cùng hàng nghìn nhà bán hàng đang kinh doanh sản phẩm tùy chỉnh với Printway",
      "title": "Bắt đầu kinh doanh POD ngay hôm nay"
    },
    "or": "HOẶC",
    "registerCta": "Đăng ký",
    "sso": {
      "google": "Tiếp tục với Google",
      "lark": "Tiếp tục với Lark Suite"
    },
    "verifyEmail": {
      "errors": {
        "invalid": "Mã OTP không đúng. Vui lòng thử lại.",
        "expired": "Mã OTP đã hết hạn. Nhấn \"Gửi lại\" để nhận mã mới.",
        "rateLimit": "Quá nhiều lần thử. Vui lòng đợi.",
        "generic": "Xác minh thất bại. Vui lòng thử lại.",
        "resendRateLimit": "Vui lòng đợi trước khi gửi lại.",
        "resendGeneric": "Gửi lại OTP thất bại. Thử lại sau."
      },
      "resendSuccess": "Đã gửi lại mã OTP. Vui lòng kiểm tra email.",
      "missingEmailTitle": "Không có email cần xác minh",
      "missingEmailBody": "Vui lòng quay lại trang đăng ký.",
      "backToRegister": "← Đăng ký",
      "title": "Xác minh email",
      "subtitle": "Chúng tôi đã gửi mã 6 chữ số đến:",
      "otpLabel": "Mã OTP 6 chữ số",
      "submit": "Xác minh",
      "didNotReceive": "Không nhận được mã?",
      "resend": "Gửi lại",
      "backToLogin": "← Đăng nhập",
      "resendCooldown": "Gửi lại ({{n}}s)"
    }
  },
  "currency": {
    "tooltip": "Nguồn quy đổi: USD. Tỉ giá: {{rate}} {{display}}/USD @ {{fetchedAt}}.",
    "fallback": "Hiện hiển thị USD do tỉ giá tạm không khả dụng."
  },
  "datetime": {
    "justNow": "Vừa xong",
    "secondsAgo": "{{count}} giây trước",
    "minutesAgo": "{{count}} phút trước",
    "hoursAgo": "{{count}} giờ trước",
    "daysAgo": "{{count}} ngày trước",
    "yesterday": "Hôm qua",
    "tomorrow": "Ngày mai",
    "in": "{{value}}"
  },
  "errors": {
    "403": {
      "code": "403",
      "title": "Không có quyền truy cập",
      "subtitle": "Tài khoản của bạn không có quyền vào trang này. Liên hệ Quản trị viên nếu bạn nghĩ đây là nhầm lẫn.",
      "contactAdmin": "Liên hệ Admin"
    },
    "404": {
      "code": "404",
      "title": "Trang không tồn tại",
      "subtitle": "Đường dẫn bạn đang truy cập không tồn tại hoặc đã được di chuyển.",
      "backHome": "Về trang chính"
    },
    "500": {
      "code": "500",
      "title": "Server đang gặp sự cố",
      "subtitle": "Yêu cầu của bạn không hoàn tất. Vui lòng thử lại trong giây lát.",
      "retry": "Thử lại",
      "statusPage": "Trang trạng thái"
    },
    "_comment": "Phase 6 Wave 12 Task 43 — adds 404/403/500 dedicated error-page copy. vg-binding: PLAN:task-43 / P6.D-204",
    "generic": "Đã có lỗi xảy ra. Vui lòng thử lại.",
    "network": "Mất kết nối — kiểm tra mạng và thử lại.",
    "unauthorized": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    "forbidden": "Bạn không có quyền thực hiện thao tác này.",
    "validation": "Dữ liệu không hợp lệ. Kiểm tra các trường đánh dấu đỏ.",
    "rate_limited": "Bạn thao tác quá nhanh — vui lòng thử lại sau ít phút.",
    "server": "Máy chủ tạm gặp sự cố. Vui lòng thử lại.",
    "fx_provider_unavailable": "Tạm thời không lấy được tỉ giá. Hiển thị USD.",
    "maintenance": {
      "title": "Đang bảo trì",
      "subtitle": "Hệ thống đang được bảo trì. Vui lòng quay lại sau ít phút.",
      "retry": "Thử lại"
    }
  },
  "promo": {
    "_comment": "Phase 6 Wave 12 Task 43 — Promo banner copy (P6.D-222). vg-binding: PLAN:task-43 / P6.D-222 / G-72",
    "dismiss": "Đóng",
    "cta": "Tìm hiểu"
  },
  "security": {
    "_comment": "Phase 6 Wave 12 Task 43 — Suspend overlay copy (P6.D-114). vg-binding: PLAN:task-43 / P6.D-114",
    "suspend": {
      "overlay": {
        "title": "Tài khoản đang tạm ngưng",
        "body": "Truy cập bị giới hạn. Liên hệ Admin Support để khôi phục.",
        "cta": "Liên hệ Support"
      }
    }
  },
  "artwork": {
    "nav": {
      "label": "Thư viện thiết kế"
    },
    "empty": "Chưa có file nào trong thư mục này.",
    "folder": {
      "new": "+ Thư mục mới",
      "root": "Tất cả thiết kế",
      "collapse": "Thu gọn",
      "expand": "Mở rộng"
    },
    "view": {
      "grid": "Lưới",
      "list": "Danh sách",
      "listAria": "Xem dạng danh sách",
      "gridAria": "Xem dạng lưới"
    },
    "list": {
      "colThumb": "Ảnh",
      "colName": "Tên file",
      "colSize": "Dung lượng",
      "colUploaded": "Ngày tải lên",
      "colUsed": "Đang dùng"
    },
    "upload": {
      "trigger": "Tải lên",
      "dropHere": "Kéo thả file vào đây hoặc nhấn để chọn",
      "browse": "Bấm để duyệt file",
      "maxSizeSync": "Đồng bộ ≤10MB",
      "async": "Bất đồng bộ >10MB",
      "maxFiles": "Chỉ tải lên tối đa {{max}} ảnh mỗi lần.",
      "tooLarge": "Ảnh vượt quá 100MB."
    },
    "bulk": {
      "selectedCount": "Đã chọn {{count}} file",
      "move": "Di chuyển",
      "delete": "Xóa",
      "downloadZip": "Tải ZIP",
      "deleteError": "Không thể xoá artwork. Hãy thử lại.",
      "deleteSuccess": "Đã xoá {{count}} artwork.",
      "moveError": "Không thể chuyển artwork. Hãy thử lại.",
      "moveSuccess": "Đã chuyển {{count}} artwork vào {{folder}}.",
      "needSelection": "Chọn artwork trước (tick ô vuông góc trên-trái card).",
      "deleteSuccess_one": "Đã xoá {{count}} artwork.",
      "deleteSuccess_other": "Đã xoá {{count}} artwork.",
      "moveSuccess_one": "Đã chuyển {{count}} artwork vào {{folder}}.",
      "moveSuccess_other": "Đã chuyển {{count}} artwork vào {{folder}}."
    },
    "lightbox": {
      "metadata": "Thông tin file",
      "dpi": "DPI",
      "dimensions": "Kích thước",
      "format": "Định dạng",
      "size": "Dung lượng",
      "uploaded": "Tải lên",
      "usedIn": "Dùng trong sản phẩm",
      "usedInEmpty": "Chưa được sử dụng.",
      "download": "Tải xuống",
      "edit": "Chỉnh sửa",
      "rename": "Đổi tên",
      "move": "Di chuyển",
      "delete": "Xóa",
      "prev": "Trước",
      "next": "Sau",
      "zoomIn": "Phóng to",
      "zoomOut": "Thu nhỏ",
      "rootFolder": "(gốc)",
      "ok": "OK"
    },
    "editor": {
      "title": "Chỉnh sửa thiết kế",
      "crop": "Cắt",
      "rotate": "Xoay",
      "resize": "Đổi kích thước",
      "reset": "Hoàn tác",
      "save": "Lưu",
      "saving": "Đang lưu...",
      "savedToast": "Đã lưu thiết kế mới",
      "saveErrorToast": "Lỗi lưu thiết kế",
      "cropHint": "Kéo để chọn vùng cắt",
      "widthLabel": "Rộng (px)",
      "heightLabel": "Cao (px)",
      "mockupOverlayNote": "Xem trước mockup là ảnh tĩnh — chỉnh sửa vị trí trong Editor nâng cao (sắp ra mắt)"
    },
    "badge": {
      "embroidery": "Thêu",
      "new": "MỚI",
      "usedIn": "Dùng {{count}}"
    },
    "quota": {
      "label": "Đã dùng: {{used}} / {{limit}}",
      "warn80": "Bộ nhớ đã dùng vượt 80%. Hãy dọn dẹp file cũ.",
      "warn90": "Bộ nhớ đã dùng vượt 90%. Sắp hết dung lượng!",
      "blocked": "Bộ nhớ đã đầy. Không thể tải thêm file."
    },
    "mapping": {
      "suggest": "Gán file này cho Đơn #{{orderNumber}}?"
    },
    "grid": {
      "selectAria": "Chọn {{name}}"
    },
    "folderPicker": {
      "count": "{{shown}} / {{total}} thư mục",
      "title": "Chuyển {{count}} artwork đến folder",
      "subtitle": "Chọn folder đích, hoặc Root để bỏ khỏi folder.",
      "search": "Tìm folder theo tên…",
      "noMatch": "Không có folder nào khớp.",
      "empty": "Chưa có folder nào — tạo folder ở sidebar.",
      "hint": "Mẹo: double-click để chọn nhanh.",
      "confirm": "Chuyển vào đây",
      "title_one": "Chuyển {{count}} artwork đến folder",
      "title_other": "Chuyển {{count}} artwork đến folder"
    },
    "batch": {
      "error": "Không tìm thấy lô tải lên.",
      "progress": "{{succeeded}}/{{total}} xong · {{failed}} lỗi",
      "fileError": "Tệp không hợp lệ.",
      "title": "Lô tải lên ({{count}} tệp)",
      "title_one": "Lô tải lên ({{count}} tệp)",
      "title_other": "Lô tải lên ({{count}} tệp)"
    },
    "move": {
      "error": "Không thể chuyển artwork. Hãy thử lại.",
      "success": "Đã chuyển artwork vào {{folder}}"
    }
  },
  "orders": {
    "_comment": "Phase 6 Wave 6 Task 17 — Orders list page copy. vg-binding: PLAN:task-17 / P6.D-40 / P6.D-41 / P6.D-42 / P6.D-43 / P6.D-47 / P6.D-48",
    "artwork": {
      "_comment": "Phase 4.9 Wave 5 Task 14 — order-import artwork-ingest copy. vg-binding: PLAN:task-14 / P4.9.D-18 / P4.9.D-19 / P4.9.D-20",
      "section": {
        "title": "Xử lý artwork"
      },
      "aggregate": {
        "processing": "Đang xử lý artwork",
        "ready": "Artwork sẵn sàng",
        "error": "Lỗi artwork"
      },
      "status": {
        "pending": "Chờ xử lý",
        "downloading": "Đang tải",
        "validating": "Đang kiểm tra",
        "retrying": "Đang thử lại",
        "validated": "Hợp lệ",
        "error": "Lỗi"
      },
      "action": {
        "editLink": "Sửa link",
        "reIngest": "Tải lại",
        "manualUpload": "Upload thủ công",
        "unauthorized": "Vui lòng đăng nhập lại để tiếp tục.",
        "forbidden": "Bạn không có quyền thao tác trên đơn này."
      },
      "error": {
        "GENERIC": "Không thể xử lý artwork này.",
        "ARTWORK_LINK_UNREACHABLE": "Không truy cập được link artwork. Kiểm tra lại URL và quyền truy cập.",
        "ARTWORK_FILE_TOO_LARGE": "File artwork quá lớn.",
        "ARTWORK_EXTENSION_INVALID": "Định dạng file artwork không được hỗ trợ.",
        "ARTWORK_DIMENSION_MISMATCH": "Kích thước artwork không khớp với vùng in.",
        "ARTWORK_DPI_TOO_LOW": "Độ phân giải (DPI) của artwork quá thấp để in.",
        "ARTWORK_DECODE_FAILED": "Không giải mã được file artwork.",
        "ARTWORK_SSRF_REJECTED": "Link artwork trỏ tới địa chỉ bị chặn.",
        "ARTWORK_TEMPLATE_MISSING": "Thiếu template in cho vùng này.",
        "ARTWORK_SYSTEM_ERROR": "Có lỗi xảy ra khi xử lý artwork."
      },
      "thumb": {
        "alt": "Ảnh thu nhỏ artwork",
        "openPreview": "Xem ảnh lớn"
      },
      "preview": {
        "alt": "Xem trước artwork"
      },
      "polling": {
        "timeout": "Kiểm tra lại sau — làm mới"
      },
      "editLink": {
        "title": "Cập nhật link artwork",
        "body": "Dán link công khai mới cho vùng in này. Hệ thống sẽ tải lại và kiểm tra.",
        "label": "Link artwork",
        "submit": "Cập nhật & tải lại",
        "saving": "Đang lưu…"
      },
      "link": {
        "updated": "Đã cập nhật link và xếp hàng tải lại."
      },
      "reingest": {
        "queued": "Đã xếp hàng tải lại artwork."
      },
      "upload": {
        "queued": "Đã tải lên artwork và xếp hàng kiểm tra lại."
      },
      "filter": {
        "label": "Trạng thái artwork",
        "activeLabel": "Đang lọc theo trạng thái artwork:"
      },
      "original": {
        "alt": "Artwork gốc",
        "badge": "Ảnh gốc"
      },
      "requiredSpecs": "Yêu cầu: ",
      "actualSpecs": "Ảnh thực tế: ",
      "requiredVsActual": "cần {{required}} · ảnh: {{actual}}"
    },
    "create": {
      "_comment": "Phase 6 Wave 6 Task 19 — Order Create Wizard copy. vg-binding: PLAN:task-19 / P6.D-52..58 / P6.D-60 / P6.D-61 / G-34",
      "title": "Tạo đơn hàng",
      "type": {
        "basic": "Cơ bản",
        "sample": "Mẫu",
        "bulk": "Số lượng lớn"
      },
      "bulkType": {
        "fba": "FBA",
        "fbt": "FBT",
        "general": "Tổng quát"
      },
      "step": {
        "products": "Sản phẩm",
        "design": "Tạo thiết kế",
        "checkout": "Thanh toán"
      },
      "context": {
        "store": {
          "label": "Store",
          "placeholder": "Chọn store…",
          "auto": "Tự chọn sẵn",
          "locked": "Store cố định khi sửa/đặt lại đơn",
          "changeTitle": "Đổi store?",
          "changeBody": "Đổi store sẽ xoá giỏ hàng hiện tại — sản phẩm thuộc về store đã chọn.",
          "changeConfirm": "Đổi store"
        },
        "type": {
          "label": "Loại đơn",
          "basic": "Cơ bản",
          "sample": "Đơn mẫu",
          "bulk": "Đơn sỉ"
        },
        "bulkType": {
          "label": "Loại đơn sỉ"
        },
        "gate": {
          "store": "Chọn store để tiếp tục",
          "sampleReason": "Chọn lý do đặt mẫu để tiếp tục",
          "bulkType": "Chọn loại đơn sỉ để tiếp tục"
        }
      },
      "products": {
        "selectProducts": "Chọn sản phẩm",
        "modal": {
          "title": "Chọn sản phẩm",
          "searchPlaceholder": "Tìm sản phẩm…",
          "category": "Danh mục",
          "collection": "Bộ sưu tập",
          "location": "Địa điểm sản xuất",
          "allCategories": "Tất cả danh mục",
          "allCollections": "Tất cả bộ sưu tập",
          "allLocations": "Tất cả địa điểm",
          "loading": "Đang tải…",
          "loadError": "Không tải được danh sách sản phẩm. Vui lòng thử lại.",
          "noResults": "Không có sản phẩm nào khớp bộ lọc này.",
          "fromPrice": "Từ {{price}}",
          "variantCount": "{{count}} biến thể",
          "selectedCount": "Đã chọn {{count}} sản phẩm",
          "selectHint": "Chọn ít nhất một sản phẩm để tiếp tục.",
          "cancel": "Huỷ",
          "startOrder": "Bắt đầu đơn hàng",
          "filterUnavailable": "Không khả dụng",
          "filtersError": "Một số bộ lọc không tải được. Bạn vẫn duyệt và tìm kiếm được.",
          "search": "Tìm kiếm",
          "tabs": {
            "myProducts": "Sản phẩm của tôi",
            "catalog": "Catalog"
          },
          "myProducts": {
            "empty": "Không có sản phẩm nào của bạn khớp bộ lọc.",
            "browseCatalog": "Xem catalog",
            "locked": "Không còn được phép đặt hàng",
            "noBlueprint": "Sản phẩm gốc không còn khả dụng",
            "droppedUnavailable_one": "{{count}} sản phẩm đã chọn không còn đặt hàng được và đã bị bỏ chọn.",
            "droppedUnavailable_other": "{{count}} sản phẩm đã chọn không còn đặt hàng được và đã bị bỏ chọn."
          }
        },
        "page": {
          "title": "Tạo đơn hàng",
          "subtitle": "Hoàn tất tuỳ chọn vận chuyển và gửi thông tin giao hàng của khách",
          "store": "Cửa hàng",
          "storePlaceholder": "Chọn cửa hàng…",
          "storeLoading": "Đang tải cửa hàng…",
          "storeChangeTitle": "Đổi cửa hàng?",
          "storeChangeBody": "Đổi cửa hàng sẽ xoá các sản phẩm đã thêm vào đơn này.",
          "addProduct": "Thêm sản phẩm",
          "shipping": "Vận chuyển",
          "pay": "Thanh toán",
          "orderName": "Tên đơn hàng",
          "orderNamePlaceholder": "ORD-2024-001"
        },
        "cart": {
          "empty": "Chưa có sản phẩm nào trong đơn này."
        },
        "line": {
          "location": "Địa điểm",
          "qty": "SL",
          "itemCost": "Đơn giá",
          "total": "Thành tiền",
          "note": "Ghi chú",
          "notePlaceholder": "Thêm hướng dẫn giao hàng cụ thể tại đây...",
          "loadingVariants": "Đang tải biến thể…",
          "noLocation": "Không có địa điểm khả dụng",
          "variantsError": "Không tải được biến thể của sản phẩm này.",
          "variantUnavailable": "Tổ hợp này không có sẵn — hãy chọn tuỳ chọn khác để tiếp tục.",
          "noPrintAreas": "Sản phẩm này chưa cấu hình vùng in.",
          "myProductUnavailable": "Sản phẩm này không còn đặt hàng được. Hãy xoá để tiếp tục.",
          "myProductLoadError": "Không tải được sản phẩm này.",
          "retry": "Thử lại",
          "artworkDetached_one": "{{count}} file artwork không khớp vùng in của biến thể này nên đã bị gỡ khỏi dòng. File vẫn còn trong thư viện.",
          "artworkDetached_other": "{{count}} file artwork không khớp vùng in của biến thể này nên đã bị gỡ khỏi dòng. File vẫn còn trong thư viện."
        },
        "artwork": {
          "uploaded": "Đã thêm thiết kế",
          "uploadFailed": "Tải lên thất bại",
          "rejected": "Tệp bị từ chối"
        },
        "subtotal": "Tạm tính"
      },
      "artwork": {
        "assign": {
          "fromLibrary": "Chọn từ thư viện",
          "upload": "Tải lên mới",
          "remove": "Xoá"
        },
        "assigned": "Đã gán",
        "unassigned": "Chưa gán",
        "incomplete": "Cần gán artwork cho các vùng in bắt buộc",
        "libraryPicker": {
          "title": "Chọn artwork từ thư viện",
          "search": "Tìm theo tên…",
          "empty": "Thư viện trống. Upload artwork tại /artwork hoặc dùng nút \"Upload mới\".",
          "noMatch": "Không có artwork khớp.",
          "confirm": "Chọn"
        },
        "required": "Bắt buộc",
        "optional": "Tuỳ chọn",
        "choose": {
          "title": "Chọn artwork",
          "uploadTitle": "Nhấn hoặc kéo tệp vào vùng này để tải lên",
          "search": "Tìm theo tên artwork",
          "empty": "Chưa có artwork nào — hãy tải lên ở phía trên.",
          "noMatch": "Không có artwork nào khớp tên đó.",
          "listError": "Không tải được thư viện artwork của bạn.",
          "wrongSize": "{{actual}} ≠ yêu cầu {{required}}",
          "apply": "Áp dụng cho {{area}}"
        }
      },
      "shipping": {
        "field": {
          "name": "Họ và tên",
          "line1": "Địa chỉ 1",
          "line2": "Địa chỉ 2 (Không bắt buộc)",
          "city": "Thành phố",
          "state": "Tỉnh/Bang",
          "postalCode": "Mã bưu chính",
          "country": "Quốc gia",
          "phone": "Số điện thoại",
          "email": "Email",
          "line2Placeholder": "Căn hộ, phòng, tầng...",
          "taxNumber": "Mã số thuế",
          "note": "Ghi chú",
          "notePlaceholder": "Thêm hướng dẫn giao hàng cụ thể tại đây..."
        },
        "validate": {
          "button": "Kiểm tra",
          "valid": "Hợp lệ",
          "warn": "Cảnh báo",
          "invalid": "Không hợp lệ"
        },
        "suggestion": {
          "apply": "Áp dụng đề xuất"
        },
        "gps": {
          "button": "Lấy vị trí hiện tại"
        },
        "fba": {
          "warehouse": "Kho FBA",
          "fnsku": "FNSKU"
        },
        "search": {
          "country": "Tìm quốc gia…",
          "state": "Tìm bang/tỉnh…",
          "city": "Tìm thành phố…"
        },
        "state": {
          "none": "Không có tỉnh/bang"
        },
        "method": {
          "label": "Phương thức giao hàng",
          "merchant": "Ship by merchant",
          "merchantDesc": "Merchant tự giao — điền địa chỉ nhận hàng.",
          "tiktok": "Label từ sàn (Marketplace)",
          "tiktokDesc": "Upload label do sàn cung cấp (TikTok, Etsy…) — không cần điền địa chỉ.",
          "loading": "Đang tải phương thức vận chuyển…",
          "none": "Nhập địa chỉ giao hàng để xem các phương thức vận chuyển khả dụng.",
          "sampleFree": "Đơn mẫu được miễn phí vận chuyển — không thu phí ship."
        },
        "label": {
          "title": "Upload shipping label",
          "help": "PDF hoặc ảnh. Label đã có thông tin người nhận nên không cần điền địa chỉ.",
          "modeUpload": "Tải file lên",
          "modeLink": "Nhập link",
          "missingUpload": "Chọn file label để tiếp tục.",
          "missingLink": "Dán link label để tiếp tục."
        },
        "country": "Quốc gia",
        "line1": "Địa chỉ dòng 1",
        "line2": "Địa chỉ dòng 2 (tùy chọn)",
        "phone": "Số điện thoại",
        "postal": "Mã bưu chính",
        "rate": {
          "calculating": "Đang tính phí…",
          "eta": "{{min}}–{{max}} ngày làm việc",
          "title": "Phí vận chuyển",
          "fillAddress": "Nhập đủ địa chỉ (line 1, city, country) để xem phương thức + giá ship."
        },
        "recipient": "Tên người nhận",
        "infoTitle": "Thông tin giao hàng",
        "methodTitle": "Phương thức vận chuyển",
        "sampleCountryLocked": "Đơn mẫu được giao tới xưởng Việt Nam của chúng tôi."
      },
      "review": {
        "subtotal": "Tạm tính",
        "shipping": "Vận chuyển",
        "tax": "Thuế",
        "embroideryCost": "Thêu",
        "total": "Tổng cộng",
        "title": "Xem lại đơn hàng",
        "table": {
          "product": "Sản phẩm",
          "variant": "Biến thể",
          "qty": "SL",
          "artwork": "Thiết kế",
          "subtotal": "Tạm tính"
        },
        "embroidery": {
          "title": "Tuỳ chọn thêu",
          "threadColor": "Màu chỉ",
          "position": "Vị trí",
          "digitizingFee": "Phí số hoá"
        },
        "continueToPayment": "Tiếp tục thanh toán",
        "customer": "Khách hàng",
        "itemsTitle": "Sản phẩm trong đơn ({{count}})",
        "noCustomer": "Chưa có thông tin khách hàng",
        "qtyLine": "SL: {{qty}} × {{price}}",
        "saveOnly": "Lưu đơn (thanh toán sau)",
        "shippingAddress": "Địa chỉ giao hàng",
        "summaryTitle": "Tóm tắt đơn hàng",
        "taxPct": "Thuế ({{pct}})",
        "tiktokAddress": "Nhãn marketplace (không có địa chỉ)",
        "artworkChecking": "Đang kiểm tra yêu cầu artwork…",
        "artworkRequired": "Cần upload artwork cho vùng in bắt buộc: {{areas}}. Quay lại bước Artwork để hoàn tất."
      },
      "nav": {
        "next": "Tiếp",
        "back": "Quay lại",
        "save_draft": "Lưu nháp"
      },
      "orderType": {
        "sampleReason": {
          "label": "Lý do đặt mẫu (bắt buộc)",
          "quality": "Kiểm chất lượng",
          "colorMatch": "So màu thực tế",
          "proofApproval": "Duyệt bản in thử",
          "marketing": "Chụp ảnh marketing",
          "other": "Khác"
        }
      },
      "orderName": {
        "label": "Tên đơn hàng",
        "uniqueHint": "không được trùng với đơn khác",
        "placeholder": "VD: PO-2025-001 / Khách Anh Tuấn batch 1",
        "help": "Bắt buộc — dùng làm mã tham chiếu nội bộ (số PO, tên khách…). Mỗi đơn một tên riêng."
      },
      "design": {
        "skipHint": "Tạo hoặc chỉnh artwork tại đây, hoặc bỏ qua — bạn có thể upload theo từng vùng in ở bước Artwork.",
        "badge": {
          "newProduct": "Sản phẩm mới — cần artwork",
          "personalized": "Personalized — cần artwork mới",
          "fromProduct": "Artwork lấy từ sản phẩm"
        },
        "noMockup": "Chưa có ảnh mockup xem trước",
        "editBtn": "Chỉnh sửa",
        "editor": {
          "title": "Design Maker",
          "noArtwork": "Chưa chọn artwork"
        }
      },
      "confirm": {
        "title": "Xác nhận đơn hàng",
        "discount": "Mã giảm giá",
        "discountPlaceholder": "Nhập mã giảm giá",
        "discountSoon": "Tính năng mã giảm giá chưa khả dụng.",
        "apply": "Áp dụng",
        "summary": "Tóm tắt đơn hàng",
        "subtotal": "Tạm tính ({{count}} sản phẩm)",
        "shippingFee": "Phí vận chuyển",
        "taxFee": "Thuế",
        "surcharge": "Tổng phụ phí",
        "surchargeSoon": "Phụ phí chưa được tách dòng.",
        "total": "Tổng cộng",
        "paymentMethod": "Phương thức thanh toán",
        "payLater": "Thanh toán sau",
        "payLaterHint": "Tạo đơn ngay và thanh toán tại trang đơn hàng.",
        "wallet": "Ví Printway",
        "credit": "Tín dụng Printway",
        "balance": "Số dư: {{balance}}",
        "walletShort": "Số dư: {{balance}} — không đủ",
        "creditSoon": "chưa khả dụng",
        "terms": "Tôi đồng ý với điều khoản và điều kiện",
        "submit": "Tạo đơn hàng",
        "submitting": "Đang tạo…",
        "blocked": "Giá chưa sẵn sàng. Vui lòng đợi trong giây lát.",
        "failed": "Không tạo được đơn hàng. Vui lòng thử lại.",
        "paidTitle": "Đã xác nhận đơn hàng",
        "draftTitle": "Đã tạo đơn hàng",
        "draftBody": "Bạn có thể thanh toán bất cứ lúc nào tại trang đơn hàng.",
        "termsPrefix": "Tôi đồng ý với",
        "termsLink": "Điều khoản & Điều kiện"
      },
      "validation": {
        "required": "Trường này là bắt buộc",
        "emailInvalid": "Nhập địa chỉ email hợp lệ",
        "phoneInvalid": "Nhập số điện thoại hợp lệ",
        "storeRequired": "Chọn cửa hàng cho đơn hàng này",
        "noLines": "Thêm ít nhất một sản phẩm",
        "unresolvedVariant": "Mỗi sản phẩm cần chọn một phiên bản",
        "artworkRequired": "Tải lên artwork cho mọi vùng in bắt buộc",
        "artworkAreasMissing": "Tải lên artwork cho: {{areas}}",
        "methodRequired": "Chọn phương thức vận chuyển",
        "orderNameRequired": "Nhập tên cho đơn hàng này",
        "productUnavailable": "Có sản phẩm chưa xác nhận được là còn đặt hàng — thử lại hoặc xoá sản phẩm đó",
        "productLoading": "Đang kiểm tra sản phẩm của bạn — thử lại sau giây lát"
      }
    },
    "import": {
      "_comment": "Phase 6 Wave 6 Task 20 — Excel Import wizard copy. vg-binding: PLAN:task-20 / P6.D-62 / P6.D-63 / G-35",
      "navLabel": "Nhập đơn từ Excel",
      "title": "Nhập đơn từ Excel",
      "step": {
        "upload": "Tải lên",
        "matching": "Map cột",
        "review": "Xem lại",
        "payment": "Thanh toán",
        "result": "Kết quả",
        "aria": "Các bước nhập đơn",
        "downloadFailed": "Tải xuống thất bại",
        "uploadFailed": "Tải lên thất bại",
        "presetLoadFailed": "Tải preset thất bại",
        "saveFailed": "Lưu thất bại",
        "quoteFailed": "Báo giá thất bại",
        "commitFailed": "Xác nhận thất bại"
      },
      "upload": {
        "dropHere": "Kéo thả XLSX/CSV...",
        "templateDownload": "Tải template",
        "button": "Tải file lên",
        "uploading": "Đang tải lên...",
        "invalidType": "Định dạng không hỗ trợ",
        "xlsxNote": "Xem trước sau khi máy chủ xử lý"
      },
      "matching": {
        "title": "Map cột",
        "preset": {
          "label": "Preset",
          "save": "Lưu preset",
          "namePrompt": "Tên preset:"
        },
        "col": {
          "field": "Trường Printway",
          "column": "Cột trong file"
        },
        "field": {
          "orderNumber": "Mã đơn",
          "customerName": "Tên khách hàng",
          "customerEmail": "Email khách hàng",
          "addressLine1": "Địa chỉ",
          "city": "Thành phố",
          "state": "Tỉnh / Bang",
          "postalCode": "Mã bưu điện",
          "country": "Quốc gia",
          "productSku": "SKU sản phẩm",
          "qty": "Số lượng",
          "artworkUrl_print_area_1": "URL thiết kế vùng 1",
          "artworkUrl_print_area_2": "URL thiết kế vùng 2",
          "embroidery_thread_color": "Màu chỉ thêu"
        }
      },
      "review": {
        "errorsOnly": "Chỉ lỗi",
        "empty": "Không có dòng nào",
        "totals": {
          "orders": "Tổng số đơn",
          "errors": "Số lỗi",
          "estimated": "Tổng ước tính",
          "grouped": "{{rows}} dòng → {{orders}} đơn (gộp theo order_name)"
        }
      },
      "payment": {
        "method": {
          "wallet": "Ví",
          "cc": "Thẻ tín dụng",
          "paypal": "PayPal",
          "payLater": "Thanh toán sau"
        },
        "batchNote": "Một giao dịch duy nhất cho cả batch",
        "payLaterNote": "Đơn sẽ được tạo ở trạng thái nháp chưa thanh toán — bạn thanh toán từng đơn sau ở danh sách Orders.",
        "commit": "Tạo đơn hàng loạt",
        "committing": "Đang xử lý..."
      },
      "result": {
        "success": "Thành công: {{count}}",
        "failed": "Thất bại: {{count}}",
        "errorsDownload": "Tải CSV lỗi",
        "orderIds": "Đơn đã tạo",
        "restart": "Nhập batch khác"
      },
      "progress": {
        "percent": "{{pct}}% — {{processed}}/{{total}} đơn"
      },
      "nav": {
        "next": "Tiếp",
        "back": "Quay lại"
      },
      "action": "Nhập"
    },
    "nav": {
      "label": "Đơn hàng"
    },
    "list": {
      "title": "Danh sách đơn hàng",
      "emptyState": {
        "noMatchFilter": "Không có đơn hàng nào khớp với bộ lọc hiện tại."
      },
      "error": {
        "loadFailed": "Không tải được đơn hàng"
      },
      "dateRange": {
        "last7": "7 ngày qua",
        "last30": "30 ngày qua",
        "last90": "90 ngày qua",
        "allTime": "Tất cả thời gian",
        "from": "Từ",
        "to": "Đến",
        "done": "Xong"
      },
      "bulkDiscount": {
        "itemsOrdered": "Số lượng đặt",
        "itemsThreshold": "10+ sản phẩm",
        "shipping": "Giảm phí vận chuyển",
        "shippingValue": "Tối đa 10%",
        "product": "Giảm giá sản phẩm",
        "productValue": "Tối đa 5%"
      },
      "store": {
        "manual": "Đơn thủ công",
        "all": "Tất cả cửa hàng",
        "search": "Tìm cửa hàng…"
      },
      "cancelConfirm_one": "Huỷ {{count}} đơn?",
      "cancelConfirm_other": "Huỷ {{count}} đơn?",
      "createOrder": "Tạo đơn",
      "createTicket": "Tạo ticket",
      "sound": {
        "on": "Âm báo đơn mới: Bật",
        "off": "Âm báo đơn mới: Tắt"
      },
      "dateRangePicker": "Khoảng thời gian",
      "paymentFilter": "Trạng thái thanh toán",
      "productFilter": {
        "label": "Loại sản phẩm",
        "selected": "Sản phẩm",
        "empty": "Không tìm thấy sản phẩm",
        "search": "Tìm sản phẩm"
      },
      "statusFilter": "Trạng thái",
      "storeFilter": "Cửa hàng",
      "tabsLabel": "Trạng thái đơn",
      "cancelConfirm": "Hủy {{count}} đơn hàng?",
      "sendToProduction": {
        "cta": "Gửi sản xuất",
        "sending": "Đang gửi…",
        "success": "Đã gửi đơn hàng vào sản xuất.",
        "tooltipSend": "Gửi đơn này cho nhà cung cấp để bắt đầu sản xuất.",
        "tooltipNotWaiting": "Chỉ đơn đã thanh toán và đang chờ duyệt mới có thể gửi sản xuất."
      },
      "bulkSend": {
        "success": "Đã gửi {{assigned}} đơn vào sản xuất, {{blocked}} bị chặn.",
        "error": "Gửi hàng loạt thất bại. Vui lòng thử lại."
      },
      "bulkSendResult": {
        "title": "Kết quả gửi sản xuất",
        "summary": "{{assigned}} đã gửi · {{blocked}} bị chặn · {{total}} tổng",
        "assigned": "Đã gửi sản xuất",
        "blocked": "Bị chặn",
        "itemsAssigned": "{{count}} sản phẩm đã phân công",
        "close": "Đóng",
        "orderLabel": "Đơn {{id}}",
        "reason": {
          "ARTWORK_NOT_VALIDATED": "Artwork chưa được xác thực",
          "FORBIDDEN_TENANT": "Không được phép",
          "INVALID_STATE": "Không ở trạng thái có thể gửi",
          "NOT_FOUND": "Không tìm thấy đơn hàng",
          "unknown": "Bị chặn"
        }
      },
      "shippingNameSearch": "Người nhận",
      "moreFilters": "Thêm bộ lọc",
      "sourceTabsLabel": "Nguồn đơn hàng",
      "sourceTab": {
        "my": "Đơn của tôi",
        "external": "Đơn từ sàn"
      },
      "orderSearch": "Mã đơn",
      "dateFrom": "Từ {{date}}",
      "dateUntil": "Đến {{date}}",
      "filter": {
        "statusAll": "Trạng thái: Tất cả",
        "clearHint": "Bấm lại để bỏ chọn"
      },
      "shippingStatusFilter": "Trạng thái vận chuyển",
      "shipping": {
        "merchant": "Merchant tự ship",
        "tiktokLabel": "Nhãn TikTok"
      },
      "creationTypeFilter": "Cách tạo đơn",
      "creation": {
        "merchant": "Merchant tự tạo",
        "admin": "Admin tạo",
        "api": "Qua API",
        "other": "Khác"
      }
    },
    "tab": {
      "all": "Tất cả",
      "draft": "Nháp",
      "pending": "Chờ",
      "processing": "Đang xử lý",
      "shipped": "Đã gửi",
      "delivered": "Đã giao",
      "issues": "Vấn đề",
      "unverified": "Chưa xác minh",
      "waiting": "Chờ duyệt",
      "late": "Trễ"
    },
    "search": {
      "placeholder": "Tìm theo mã đơn, tên đơn, khách hàng, email…",
      "recent": "Gần đây"
    },
    "bulk": {
      "_comment": "Phase 6 Wave 6 Task 21 — keys mở rộng cho popup hành động hàng loạt.",
      "selectedCount": "Đã chọn {{count}} đơn",
      "cancel": "Hủy đơn hàng",
      "export": "Xuất CSV",
      "maxWarn": "Tối đa 200 đơn cho mỗi lần xử lý hàng loạt",
      "title": "Hành động hàng loạt",
      "actionLabel": "Hành động",
      "tagLabel": "Giá trị tag",
      "tagRequired": "Nhập giá trị tag",
      "moreActions": "Thao tác khác",
      "maxLabel": "{{n}} đơn được chọn (tối đa 200)",
      "partialToast": "{{ok}}/{{total}} thành công, {{fail}} thất bại",
      "action": {
        "cancel": "Huỷ",
        "export": "Xuất",
        "retag": "Gán lại tag",
        "markShipped": "Đánh dấu đã giao",
        "retrigger": "Kích hoạt lại"
      },
      "confirm": {
        "cancel": "Huỷ {{n}} đơn?",
        "export": "Xuất {{n}} đơn ra CSV?",
        "retag": "Gán tag cho {{n}} đơn?",
        "markshipped": "Đánh dấu {{n}} đơn đã giao?",
        "retrigger": "Kích hoạt lại fulfilment cho {{n}} đơn?"
      },
      "actionFailed": "Thao tác hàng loạt thất bại",
      "pay": {
        "confirmBody": "{{count}} đơn — tổng {{amount}}. Chọn phương thức thanh toán bên dưới.",
        "confirmCta": "Xác nhận thanh toán",
        "confirmTitle": "Thanh toán các đơn đã chọn?",
        "cta": "Thanh toán",
        "genericError": "Thanh toán thất bại",
        "maxCap": "Tối đa {{n}} đơn mỗi lần thanh toán.",
        "onlyUnpaid": "Chỉ đơn chưa thanh toán mới trả được — bỏ chọn các đơn còn lại.",
        "processing": "Đang thanh toán…",
        "resultFailedHeading": "Thanh toán thất bại ({{n}}):",
        "resultPaidList": "Đã thanh toán: {{list}}",
        "singleCurrency": "Chọn các đơn cùng một loại tiền để thanh toán chung.",
        "funding": {
          "label": "Thanh toán bằng",
          "creditInsufficient": "Tín dụng không đủ cho lô đơn này (còn {{amount}})"
        }
      },
      "sendToProduction": {
        "cta": "Gửi vào sản xuất",
        "onlyWaiting": "Chỉ đơn Waiting Approval đã thanh toán mới gửi được — bỏ chọn các đơn khác."
      },
      "cancelHint": {
        "onlyPreProduction": "Chỉ hủy được đơn chưa duyệt (Nháp / Chờ duyệt). Đơn đã vào sản xuất (In Production) không thể hủy — bỏ chọn các đơn đó."
      }
    },
    "advancedFilter": {
      "_comment": "Phase 6 Wave 6 Task 21 — bộ lọc nâng cao.",
      "title": "Bộ lọc nâng cao",
      "addRule": "Thêm điều kiện",
      "apply": "Áp dụng",
      "field": "Trường",
      "operator": "Toán tử",
      "value": "Giá trị",
      "logic": "Logic",
      "operator.eq": "bằng",
      "operator.ne": "khác",
      "operator.gt": "lớn hơn",
      "operator.gte": "lớn hơn hoặc bằng",
      "operator.lt": "nhỏ hơn",
      "operator.lte": "nhỏ hơn hoặc bằng",
      "operator.contains": "chứa",
      "operator.in": "thuộc",
      "operator.notIn": "không thuộc",
      "operator.between": "trong khoảng",
      "logicOp": {
        "AND": "VÀ",
        "OR": "HOẶC",
        "WHERE": "TRONG ĐÓ"
      }
    },
    "customView": {
      "_comment": "Phase 6 Wave 6 Task 21 — trang tuỳ chỉnh view.",
      "nav": "Tuỳ chỉnh view",
      "create": "Tạo view mới",
      "edit": "Sửa view",
      "savedViews": "Các view đã lưu",
      "empty": "Chưa có view nào.",
      "selectOrCreate": "Chọn một view để sửa hoặc tạo view mới.",
      "save": "Lưu view",
      "delete": "Xoá",
      "apply": "Áp dụng",
      "public": "Công khai",
      "private": "Riêng tư",
      "noFilters": "Không có bộ lọc",
      "filterCount": "{{n}} điều kiện",
      "archive": "Lưu trữ",
      "archiveDesc": "Đơn tự động huỷ đã chuyển vào lưu trữ",
      "field": {
        "name": "Tên",
        "description": "Mô tả",
        "columns": "Cột hiển thị",
        "filters": "Bộ lọc",
        "public": "Công khai (mọi merchant đều thấy)",
        "shareWith": "Chia sẻ với merchant (id, phân tách bằng dấu phẩy)"
      },
      "error": {
        "loadFailed": "Không tải được chế độ xem",
        "saveFailed": "Lưu thất bại",
        "deleteFailed": "Xóa thất bại"
      },
      "colsCount_one": "{{count}} cột",
      "colsCount_other": "{{count}} cột",
      "filtersCount_one": "{{count}} bộ lọc",
      "filtersCount_other": "{{count}} bộ lọc",
      "column": {
        "orderNumber": "Mã đơn",
        "product": "Sản phẩm",
        "quantity": "Số lượng",
        "status": "Trạng thái",
        "platform": "Nền tảng",
        "customer": "Khách hàng",
        "items": "Mặt hàng",
        "total": "Tổng",
        "store": "Cửa hàng",
        "created": "Ngày tạo",
        "sla": "SLA",
        "actions": "Thao tác"
      }
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Lưu trữ",
      "emptyState": "Không có đơn nào trong lưu trữ."
    },
    "settings": {
      "_comment": "Phase 6 Wave 6 Task 21 — cài đặt đơn hàng merchant.",
      "title": "Cài đặt đơn hàng",
      "save": "Lưu cài đặt",
      "saved": "Đã lưu",
      "defaultSync": "Tự đồng bộ đơn từ kết nối",
      "defaultFulfillment": {
        "label": "Fulfilment mặc định",
        "option": {
          "manual": "Thủ công",
          "auto": "Tự động",
          "review": "Duyệt trước"
        }
      },
      "autoCancelTiming": "Auto-cancel sau (phút)",
      "defaultShippingService": "Dịch vụ vận chuyển mặc định",
      "holdOnInventory": "Giữ kho khi tạo đơn",
      "notificationEmail": "Email thông báo",
      "field": {
        "approvalMode": "Chế độ duyệt",
        "threshold": "Ngưỡng ($)",
        "enableNotifications": "Bật thông báo",
        "onShipped": "Khi gửi hàng",
        "onDelivered": "Khi giao hàng",
        "onExceptions": "Khi có sự cố",
        "handlingMode": "Chế độ xử lý",
        "delayThreshold": "Ngưỡng trễ (ngày)",
        "autoEscalate": "Tự động leo thang",
        "autoCancelAfter": "Tự động hủy sau (phút, 0 để tắt)",
        "defaultCarrier": "Đơn vị vận chuyển mặc định",
        "cutoffTime": "Giờ chốt đơn (HH:MM)",
        "timezone": "Múi giờ",
        "holdInventory": "Giữ tồn kho khi tạo đơn (thay vì khi xử lý)",
        "validationLevel": "Mức kiểm tra",
        "autoCorrect": "Tự động sửa lỗi chính tả khi có thể",
        "brandName": "Tên thương hiệu (Từ)",
        "replyToEmail": "Email phản hồi",
        "internalNotificationEmail": "Email thông báo nội bộ"
      },
      "option": {
        "select": "— Chọn —",
        "approval": {
          "automatic": "Tự động",
          "manual": "Thủ công",
          "threshold": "Theo ngưỡng"
        },
        "delay": {
          "manual": "Thủ công",
          "auto-escalate": "Tự động leo thang",
          "auto-reassign": "Tự động phân lại"
        },
        "fulfilment": {
          "manual": "Thủ công",
          "auto": "Tự động",
          "review": "Duyệt trước"
        },
        "addressValidation": {
          "off": "Tắt (chấp nhận mọi dữ liệu)",
          "soft": "Nhẹ (cảnh báo khi nghi ngờ)",
          "strict": "Nghiêm (chặn khi không hợp lệ)"
        }
      },
      "status": {
        "enabled": "Đã bật",
        "disabled": "Đã tắt",
        "autoSyncOn": "Tự đồng bộ BẬT",
        "autoSyncOff": "Tự đồng bộ TẮT",
        "notSet": "Chưa đặt",
        "default": "Mặc định",
        "off": "Tắt",
        "soft": "Nhẹ",
        "strict": "Nghiêm",
        "holdOnCreate": "Giữ khi tạo đơn",
        "holdAtFulfilment": "Giữ khi xử lý"
      },
      "error": {
        "loadFailed": "Tải cài đặt thất bại",
        "saveFailed": "Lưu thất bại",
        "unavailable": "Cài đặt không khả dụng"
      },
      "placeholder": {
        "storeName": "Tên cửa hàng của bạn",
        "replyToEmail": "support@yourbrand.com",
        "notificationEmail": "ops@yourbrand.com"
      },
      "approval": {
        "label": "Phê duyệt",
        "desc": "Cấu hình quy trình phê duyệt",
        "requireManager": "Yêu cầu quản lý phê duyệt",
        "title": "Phê duyệt đơn"
      },
      "automatic": "Tự động",
      "delayedOrders": "Đơn bị trễ",
      "disabled": "Tắt",
      "goTo": "Đi tới cài đặt",
      "manual": "Thủ công",
      "routing": "Định tuyến",
      "trackingNotif": "Thông báo theo dõi",
      "addressValidation": {
        "desc": "Xác thực địa chỉ giao hàng trước khi sản xuất",
        "title": "Xác thực địa chỉ"
      },
      "cancellation": {
        "desc": "Tự động huỷ đơn chưa thanh toán sau thời gian chờ",
        "title": "Huỷ đơn"
      },
      "customerComm": {
        "desc": "Danh tính email hiển thị trên tin nhắn gửi khách hàng",
        "title": "Giao tiếp với khách hàng"
      },
      "delay": {
        "desc": "Cấu hình xử lý chậm trễ và leo thang",
        "title": "Xử lý đơn bị trễ"
      },
      "infobox": "Các cài đặt này áp dụng cho mọi đơn mới mà tài khoản merchant này nhận được.",
      "inventory": {
        "desc": "Khi nào giữ kho cho đơn mới",
        "title": "Tồn kho"
      },
      "notifications": {
        "desc": "Cài đặt thông báo cho khách hàng",
        "title": "Thông báo theo dõi"
      },
      "shipping": {
        "desc": "Đơn vị vận chuyển mặc định + giờ chốt",
        "title": "Vận chuyển"
      },
      "subtitle": "Cấu hình cách đơn hàng được duyệt, theo dõi và sản xuất.",
      "sync": {
        "desc": "Tự đồng bộ từ cửa hàng đã kết nối + sản xuất mặc định",
        "title": "Đồng bộ & Sản xuất"
      }
    },
    "resend": {
      "_comment": "Phase 6 Wave 6 Task 21 — popup gửi lại đơn.",
      "title": "Gửi lại đơn",
      "reason": "Lý do",
      "submit": "Gửi lại",
      "failed": "Gửi lại thất bại"
    },
    "newBanner": {
      "one": "1 đơn hàng mới — bấm để tải",
      "other": "{{count}} đơn hàng mới — bấm để tải"
    },
    "sla": {
      "green": "Đúng hạn",
      "yellow": "Sắp tới hạn",
      "red": "Quá hạn"
    },
    "columns": {
      "toggle": "Cột",
      "preset": {
        "compact": "Gọn",
        "detailed": "Đầy đủ"
      },
      "product": "Sản phẩm",
      "qty": "SL",
      "moreItems": "sản phẩm khác",
      "order": "Đơn hàng",
      "status": "Trạng thái",
      "platform": "Nền tảng",
      "customer": "Khách hàng",
      "items": "Sản phẩm",
      "total": "Tổng cộng",
      "store": "Cửa hàng",
      "date": "Ngày",
      "sla": "SLA",
      "default": "Mặc định",
      "email": "Email",
      "surcharge": "Phụ phí",
      "orderType": "Loại đơn",
      "receivedTime": "Thời gian nhận",
      "approvedTime": "Thời gian duyệt",
      "late": "Trễ",
      "actions": "Thao tác"
    },
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "manual": "Thủ công",
      "amazon": "Amazon",
      "tiktok": "TikTok"
    },
    "detail": {
      "_comment": "Phase 6 Wave 6 Task 18 — Order detail page copy. vg-binding: PLAN:task-18 / P6.D-44..51 / P6.D-243",
      "title": "Chi tiết đơn hàng",
      "loadError": "Không tải được đơn hàng",
      "itemsTitle": "Sản phẩm",
      "address": {
        "shipping": "Địa chỉ giao hàng",
        "billing": "Địa chỉ thanh toán"
      },
      "tab": {
        "overview": "Tổng quan",
        "activity": "Hoạt động",
        "tracking": "Theo dõi"
      },
      "action": {
        "cancel": "Huỷ đơn",
        "reorder": "Đặt lại",
        "refund": "Hoàn tiền",
        "printPacking": "In packing list",
        "copied": "Đã sao chép mã đơn vào clipboard.",
        "createTicket": "Tạo ticket",
        "downloadInvoice": "Tải hoá đơn",
        "edit": "Sửa",
        "editAddress": "Sửa địa chỉ",
        "holdQueued": "Đã gửi yêu cầu tạm giữ tới bộ phận hỗ trợ. Đội ngũ của chúng tôi sẽ liên hệ sớm.",
        "invoicePending": "Tính năng tải hoá đơn chưa khả dụng. Liên hệ hỗ trợ nếu bạn cần bản sao ngay.",
        "more": "Thao tác khác",
        "payNow": "Thanh toán ngay",
        "reportIssue": "Báo cáo sự cố",
        "requestCancel": "Yêu cầu huỷ",
        "requestHold": "Yêu cầu tạm giữ",
        "sendToProduction": "Gửi vào sản xuất",
        "viewOnEtsy": "Xem trên Etsy",
        "viewOnShopify": "Xem trên Shopify",
        "viewOnSource": "Xem trên cửa hàng nguồn",
        "duplicate": "Nhân bản đơn",
        "duplicating": "Đang tạo bản sao…"
      },
      "print": {
        "popupBlocked": "Popup bị chặn — hãy cho phép popup để xem packing list."
      },
      "cost": {
        "title": "Chi phí",
        "products": "Sản phẩm",
        "shipping": "Vận chuyển",
        "tax": "Thuế",
        "handling": "Phí xử lý",
        "surcharge": "Phụ phí",
        "seasonal": "Phí mùa cao điểm",
        "tariff": "Thuế quan",
        "embroidery": "Thêu",
        "digitizing": "Số hoá thiết kế",
        "discount": "Giảm giá",
        "total": "Tổng cộng",
        "tip": {
          "products": "Tổng giá trị các dòng sản phẩm (số lượng × đơn giá).",
          "shipping": "Tính theo từng nhóm vận chuyển — có thể giao thành nhiều đợt.",
          "tax": "Thuế bán hàng / VAT — tính theo địa chỉ nhận.",
          "handling": "Phí lấy hàng / đóng gói / dán nhãn.",
          "surcharge": "Phụ phí từ vendor — ví dụ hàng quá khổ hoặc giao vùng xa.",
          "seasonal": "Phụ phí mùa cao điểm (Q4 / dịp lễ).",
          "tariff": "Thuế nhập khẩu / phí qua biên giới.",
          "embroidery": "Phí sản xuất thêu, tính theo số mũi thêu.",
          "digitizing": "Phí một lần để chuyển artwork sang file thêu.",
          "discount": "Khuyến mãi — đã được trừ sẵn."
        }
      },
      "cancel": {
        "title": "Huỷ đơn hàng",
        "submit": "Xác nhận huỷ",
        "reason": {
          "label": "Lý do",
          "customerRequest": "Khách yêu cầu",
          "duplicate": "Trùng lặp",
          "outOfStock": "Hết hàng",
          "paymentIssue": "Vấn đề thanh toán",
          "other": "Khác"
        },
        "note": {
          "label": "Ghi chú (tuỳ chọn)"
        },
        "partial": {
          "label": "Huỷ một phần"
        },
        "refund": {
          "label": "Hoàn tiền vào Số dư Ví",
          "always": "Mọi khoản hoàn về Ví — không hoàn về phương thức gốc"
        }
      },
      "activity": {
        "empty": "Chưa có hoạt động nào.",
        "actor": {
          "customer": "Khách hàng",
          "production": "Đội sản xuất",
          "system": "Hệ thống",
          "merchant": "Shop"
        },
        "showAll": "Xem tất cả {{count}}",
        "showLess": "Thu gọn",
        "loading": "Đang tải hoạt động…"
      },
      "tracking": {
        "empty": "Chưa có thông tin theo dõi.",
        "estimatedDelivery": "Giao dự kiến",
        "copyTrackingNumber": "Sao chép",
        "step": {
          "labelCreated": "Tạo nhãn",
          "pickedUp": "Đã lấy hàng",
          "inTransit": "Đang vận chuyển",
          "outForDelivery": "Đang giao",
          "delivered": "Đã giao"
        }
      },
      "shipping": {
        "method": {
          "merchant": "Ship by merchant",
          "tiktok": "Label từ sàn (Marketplace)"
        },
        "label": {
          "view": "Xem label",
          "none": "Chưa có label"
        }
      },
      "field": {
        "orderType": "Loại đơn",
        "externalOrderId": "Mã đơn bên ngoài",
        "manufacturingRegion": "Khu vực sản xuất",
        "notAssigned": "Chưa gán",
        "source": "Nguồn"
      },
      "orderType": {
        "BASIC": "Cơ bản",
        "SAMPLE": "Mẫu",
        "BULK_FBA_FBT": "Số lượng lớn (FBA/FBT)",
        "BUNDLE": "Combo"
      },
      "shippingLabelAlt": "Nhãn vận chuyển",
      "artwork": {
        "add": "Thêm artwork",
        "error": "Artwork có vấn đề — xem",
        "errorShort": "Lỗi",
        "pass": "Artwork hợp lệ — xem"
      },
      "billing": {
        "paid": "Đã thanh toán",
        "paidWithWallet": "Đã thanh toán bằng Ví",
        "productionCost": "Chi phí sản xuất",
        "shippingCost": "Chi phí vận chuyển",
        "total": "Tổng cộng",
        "transaction": "Giao dịch: {{ref}}",
        "unpaid": "Chưa thanh toán",
        "viewInvoice": "Xem hoá đơn"
      },
      "col": {
        "artwork": "Artwork",
        "product": "Sản phẩm",
        "qty": "SL",
        "shippingFee": "Phí vận chuyển",
        "sku": "SKU",
        "status": "Trạng thái",
        "total": "Tổng",
        "unitPrice": "Đơn giá"
      },
      "createdAt": "Tạo lúc {{date}}",
      "fulfillment": {
        "cancelled": "Đã huỷ",
        "delivered": "Đã giao",
        "inProgress": "Đang xử lý",
        "pending": "Chờ xử lý",
        "shipped": "Đã gửi",
        "waiting": "Chờ gán vào địa điểm sản xuất"
      },
      "item": {
        "addMoreMockup": "Thêm mockup",
        "artworkDefault": "Artwork",
        "artworks": "Artwork",
        "artworksHint": "Tải lên một file cho mỗi vùng in",
        "chooseOrDrop": "Chọn hoặc kéo thả",
        "editInWizard": "Sửa đơn",
        "formats": "Định dạng",
        "imagesCount": "{{count}} ảnh",
        "loadingAreas": "Đang tải vùng in…",
        "location": "Sản xuất",
        "lowRes": "Dưới 1000×1000px",
        "minDimensions": "Kích thước tối thiểu",
        "minResolution": "Độ phân giải tối thiểu",
        "mockups": "Mockup",
        "mockupsHint": "Ảnh xem trước sản phẩm",
        "noAreas": "Sản phẩm này chưa định nghĩa vùng in",
        "noAreasHint": "Việc gán artwork cần cấu hình vùng in của blueprint.",
        "pricing": "Giá",
        "productInfo": "Thông tin sản phẩm",
        "qtyTimesPrice": "SL × Giá",
        "qualityStandards": "Tiêu chuẩn chất lượng Printway",
        "required": "Bắt buộc",
        "savingDots": "Đang lưu…",
        "tab": {
          "design": "Thiết kế & Mockup",
          "details": "Chi tiết"
        },
        "uploadFailed": "Tải lên thất bại",
        "uploadForArea": "Tải artwork cho {{area}}",
        "uploadMockup": "Tải ảnh mockup",
        "uploadMockupHint": "Ảnh xem trước sản phẩm (PNG, JPG)",
        "uploading": "Đang tải lên…",
        "variant": "Biến thể",
        "openPreview": "Xem trước",
        "issue": {
          "heading": "Vì sao mục này bị gắn cờ",
          "errorArtwork": "Artwork của mục này xử lý không thành công. Xem vùng in bên dưới để biết cần sửa gì.",
          "onHold": "Mục này đang tạm giữ. Đội ngũ của chúng tôi đang xem xét.",
          "pendingReassignment": "Mục này đang chờ chuyển sang đối tác sản xuất khác. Bạn không cần làm gì thêm.",
          "attentionRequired": "Mục này cần được xem xét — đội ngũ của chúng tôi đã được thông báo.",
          "returnedPartial": "Mục này đã bị trả lại.",
          "partiallyCancelled": "Mục này đã bị huỷ.",
          "generic": "Mục này đang được gắn cờ để xem xét. Đội ngũ của chúng tôi đang kiểm tra — bạn không cần làm gì thêm.",
          "noAreaDetail": "Không có chi tiết theo từng vùng in cho lỗi này — lỗi phát sinh từ hệ thống xử lý của chúng tôi, không phải từ file của bạn. Hãy liên hệ hỗ trợ nếu tình trạng không tự hết."
        }
      },
      "lineItem": {
        "artworkCount": "{{count}} artwork",
        "viewArtwork": "Xem artwork & mockup"
      },
      "pay": {
        "modalTitle": "Thanh toán đơn {{order}}",
        "success": "Đã thanh toán đơn từ ví của bạn."
      },
      "refunded": {
        "label": "Đã hoàn tiền: {{amount}}"
      },
      "section": {
        "activity": "Lịch sử hoạt động",
        "billing": "Thanh toán",
        "customer": "Khách hàng",
        "fulfillment": "Sản xuất & giao hàng",
        "havingIssue": "Gặp vấn đề?",
        "havingIssueHint": "Báo cáo vấn đề về sản xuất, vận chuyển hoặc chất lượng",
        "lineItems": "Sản phẩm",
        "lineItemsHint": "Bấm vào sản phẩm để xem artwork và mockup",
        "orderInfo": "Thông tin đơn",
        "shipmentTracking": "Theo dõi vận chuyển",
        "shippingAddress": "Địa chỉ giao hàng",
        "status": "Trạng thái đơn"
      },
      "sendToProduction": {
        "confirmBody": "Đơn {{order}} sẽ được đẩy sang vendor để bắt đầu sản xuất. Sau bước này đơn chuyển sang trạng thái In Production.",
        "confirmCta": "Xác nhận gửi",
        "confirmTitle": "Gửi đơn này vào sản xuất?",
        "processing": "Đang gửi…",
        "success": "Đã gửi đơn vào sản xuất.",
        "tooltip": "Gửi đơn này cho nhà cung cấp để bắt đầu sản xuất.",
        "error": "Không thể gửi đơn vào sản xuất."
      },
      "artworkBlocked": {
        "title": "Artwork chưa được duyệt",
        "body": "Các vùng in sau cần artwork hợp lệ trước khi có thể gửi đơn này vào sản xuất.",
        "areaRow": "{{item}} — {{area}}",
        "fixCta": "Sửa artwork ngay",
        "dismiss": "Bỏ qua",
        "itemFallback": "Sản phẩm"
      },
      "shipmentTracking": {
        "empty": "Chưa có thông tin vận chuyển",
        "eta": "Dự kiến giao"
      },
      "status": {
        "cancelled": "Đơn hàng này đã bị huỷ.",
        "errorArtwork": "Đơn này có lỗi artwork — sửa line item bị đánh dấu để tiếp tục.",
        "pendingReassignment": "Đơn này đang chờ được gán lại nhà cung cấp sản xuất. Bạn không cần làm gì thêm.",
        "onHold": "Đơn này đang tạm giữ. Đội ngũ của chúng tôi đang xem lại.",
        "attentionRequired": "Đơn này cần được xem lại — vui lòng kiểm tra các line item.",
        "returnedPartial": "Một phần đơn này đã bị trả lại.",
        "partiallyCancelled": "Một phần đơn này đã bị huỷ.",
        "issueGeneric": "Đơn này cần được xem lại. Đội ngũ của chúng tôi đang kiểm tra."
      },
      "totals": {
        "shipping": "Vận chuyển",
        "subtotal": "Tạm tính",
        "tax": "Thuế",
        "total": "Tổng cộng"
      },
      "editAddress": {
        "countryLocked": "Không thể thay đổi quốc gia.",
        "save": "Lưu & xác minh lại",
        "title": "Sửa địa chỉ giao hàng"
      },
      "duplicate": {
        "success": "Đã tạo bản sao đơn — đang mở đơn mới…",
        "error": "Tạo bản sao đơn thất bại."
      }
    },
    "payment": {
      "_comment": "Phase 6 Wave 7 Task 22 — Order payment step copy. vg-binding: PLAN:task-22 / P6.D-59 / P6.D-59c / P6.D-231 / P6.D-239 / P6.D-240 / P6.D-241 / P6.D-242 / G-37 / G-38",
      "title": "Thanh toán",
      "method": {
        "wallet": "Wallet",
        "stripe": "Thẻ tín dụng (Stripe)",
        "paypal": "PayPal",
        "credit": "Tín dụng",
        "credit.insufficient": "Không đủ hạn mức tín dụng",
        "credit.subRemaining": "Khả dụng: {{remaining}}",
        "credit.expires": "hết hạn {{date}}",
        "wallet.subBalance": "Số dư hiện tại: {{balance}}",
        "insufficientBalance": "Số dư không đủ — nạp thêm",
        "topupCta": "Nạp tiền",
        "teamMemberOnly": "Team member chỉ thanh toán bằng Wallet",
        "gatewayComingSoon": "Thanh toán bằng thẻ chưa khả dụng — vui lòng dùng ví hoặc tín dụng.",
        "stripe.needsCard": "Chưa có thẻ — thêm thẻ",
        "stripe.checking": "Đang kiểm tra…",
        "stripe.willCharge": "Trừ vào {{card}}",
        "stripe.declined": "Thẻ bị từ chối — vui lòng dùng cách thanh toán khác",
        "stripe.notAllowed": "Tài khoản của bạn chưa được bật thanh toán bằng thẻ",
        "stripe.unavailable": "Không kết nối được tới cổng thanh toán — vui lòng thử lại"
      },
      "payLater": {
        "label": "Trả sau (Pay Later)",
        "help": "Tạo nợ trên Wallet — chỉ áp dụng khi chọn Wallet"
      },
      "creditDebt": {
        "warning": "Bạn nợ {{credit}}. Thanh toán bằng {{method}} không trừ nợ — cân nhắc Wallet.",
        "ack": "Tôi hiểu"
      },
      "confirm": {
        "button": "Xác nhận thanh toán",
        "processing": "Đang xử lý..."
      },
      "error": {
        "400": "Yêu cầu không hợp lệ",
        "402": "Số dư không đủ — nạp thêm trước",
        "503": "Gateway tạm thời không khả dụng — thử lại sau"
      },
      "landing": {
        "verifying": "Đang xác minh thanh toán...",
        "timeout": "Đang đối soát thanh toán. Bạn sẽ nhận thông báo khi xong.",
        "failed": {
          "title": "Thanh toán thất bại",
          "retry": "Thử lại",
          "backToOrders": "Về danh sách đơn hàng"
        },
        "success": {
          "title": "Thanh toán thành công"
        }
      },
      "paid": "Đã thanh toán",
      "partial_paid": "Thanh toán một phần",
      "unpaid": "Chưa thanh toán",
      "skip": {
        "button": "Bỏ qua thanh toán (trả sau)",
        "help": "Tạo đơn ở trạng thái Draft + Unpaid, thanh toán sau."
      }
    },
    "refund": {
      "_comment": "Phase 6 Wave 7 Task 23 — Refund flow copy. vg-binding: PLAN:task-23 / P6.D-46 / P6.D-243 / G-39",
      "title": "Hoàn tiền đơn hàng",
      "toWallet": "→ Số dư Ví",
      "disclaimer": "Refund luôn trả về Số dư Ví. Để yêu cầu hoàn về CC/PayPal gốc, liên hệ Admin Support.",
      "reason": {
        "label": "Lý do hoàn tiền",
        "defectiveProduct": "Sản phẩm lỗi",
        "wrongItemShipped": "Giao sai sản phẩm",
        "customerChangedMind": "Khách đổi ý",
        "qualityIssue": "Chất lượng",
        "shippingDamage": "Hỏng do vận chuyển"
      },
      "note": {
        "label": "Ghi chú (tuỳ chọn)"
      },
      "items": {
        "title": "Chọn sản phẩm hoàn tiền",
        "amountLabel": "Số tiền hoàn",
        "maxOriginal": "Tối đa: {{amount}}",
        "empty": "Không có sản phẩm để hoàn."
      },
      "total": {
        "label": "Tổng hoàn"
      },
      "submit": "Xác nhận hoàn tiền",
      "submitting": "Đang xử lý...",
      "success": "Hoàn tiền thành công",
      "error": "Lỗi hoàn tiền",
      "validation": {
        "minSelect": "Chọn ít nhất 1 sản phẩm",
        "exceedTotal": "Tổng hoàn vượt quá tổng đơn",
        "generic": "Không thể gửi yêu cầu — kiểm tra form."
      },
      "refundAria": "Hoàn tiền {{name}}"
    },
    "chargeback": {
      "_comment": "Phase 6 Wave 7 Task 23 — Chargeback display copy. vg-binding: PLAN:task-23 / P6.D-243 / G-39",
      "title": "Tranh chấp",
      "status": {
        "opened": "Đã mở",
        "evidenceRequired": "Cần bằng chứng",
        "lost": "Thua",
        "won": "Thắng",
        "closed": "Đã đóng"
      },
      "openedAt": "Mở lúc",
      "evidenceDueBy": "Hạn nộp bằng chứng",
      "adminHandled": "Admin Support xử lý — xem ghi chú"
    },
    "badge": {
      "draft": "Nháp",
      "unverified": "Chưa xác minh",
      "pending": "Đang chờ",
      "waiting": "Chờ duyệt",
      "processing": "Đang sản xuất",
      "shipped": "Đã gửi hàng",
      "delivered": "Hoàn thành",
      "cancelled": "Đã hủy",
      "issues": "Có vấn đề",
      "paid": "Đã thanh toán",
      "partialPaid": "Thanh toán một phần",
      "embFeeDue": "Còn nợ phí thêu",
      "unpaid": "Chưa thanh toán",
      "refunded": "Đã hoàn tiền",
      "unknown": "Không xác định",
      "waitingPayment": "Chờ thanh toán",
      "late": "Trễ hạn"
    },
    "table": {
      "header": {
        "order": "Đơn hàng",
        "status": "Trạng thái",
        "platform": "Nền tảng",
        "customer": "Khách hàng",
        "items": "Sản phẩm",
        "total": "Tổng cộng",
        "store": "Cửa hàng",
        "created": "Ngày tạo",
        "sla": "SLA",
        "orderType": "Loại đơn",
        "receivedTime": "Thời gian nhận",
        "approvedTime": "Thời gian duyệt",
        "payment": "Thanh toán",
        "shippingName": "Tên người nhận",
        "seller": "Người tạo đơn",
        "tracking": "Mã vận đơn",
        "label": "Nhãn vận chuyển",
        "location": "Nơi sản xuất",
        "embroidery": "Giá thêu",
        "surcharge": "Phụ phí",
        "email": "Email",
        "late": "Trễ hạn",
        "artwork": "Thiết kế"
      },
      "item": "sản phẩm",
      "items": "sản phẩm",
      "viewArtwork": "Xem artwork",
      "collapseItems": "Thu gọn sản phẩm",
      "expandItems": "Xem sản phẩm",
      "view": "Xem",
      "copyTracking": "Sao chép mã vận đơn",
      "trackingMore": "+{{count}} nữa",
      "locationMore": "+{{count}} nữa",
      "artworkPerItem": "{{count}} sản phẩm"
    },
    "itemStatus": {
      "draft": "Nháp",
      "unverified": "Chưa xác minh",
      "pending": "Đang chờ",
      "waiting": "Chờ duyệt",
      "processing": "Đang sản xuất",
      "shipped": "Đã gửi hàng",
      "delivered": "Đã giao",
      "cancelled": "Đã hủy",
      "issues": "Có vấn đề"
    },
    "artworkDrawer": {
      "title": "Artwork",
      "loading": "Đang tải…",
      "itemNotFound": "Không tìm thấy item.",
      "empty": "Item này không có template artwork và chưa gắn artwork nào.",
      "ingestStatus": "Trạng thái tải artwork",
      "requirementsHeading": "Yêu cầu artwork theo vùng in",
      "attached": "Đã gắn",
      "noArtwork": "Chưa có artwork",
      "requirementLabel": "Yêu cầu: ",
      "noRequirement": "Không có yêu cầu template cho vùng này.",
      "actualLabel": "Thực tế: "
    },
    "shippingField": {
      "orderName": "Tên đơn",
      "shippingLabel": "Label vận chuyển",
      "recipient": "Người nhận",
      "address": "Địa chỉ",
      "city": "Thành phố",
      "country": "Quốc gia",
      "postalCode": "Mã bưu chính"
    },
    "artworkSpec": {
      "formatInvalid": "Định dạng {{fmt}} không hợp lệ — yêu cầu {{required}}",
      "widthMismatch": "Rộng {{actual}}px ≠ yêu cầu {{required}}px",
      "heightMismatch": "Cao {{actual}}px ≠ yêu cầu {{required}}px",
      "extensionInvalid": "Định dạng {{actual}} không được chấp nhận — yêu cầu {{required}}",
      "dimensionMismatch": "Kích thước {{actual}}px không khớp yêu cầu {{required}}px",
      "dpiTooLow": "Độ phân giải {{actual}} DPI thấp hơn mức yêu cầu {{required}} DPI",
      "decodeFailed": "Không đọc được ảnh — tệp có thể bị hỏng."
    },
    "wizard": {
      "step": {
        "invalidLabelLink": "Link không hợp lệ (phải bắt đầu http:// hoặc https://)",
        "uploadLabelFailed": "Upload label thất bại",
        "uploading": "Đang upload…",
        "labelLinkPlaceholder": "https://… link tới file label",
        "labelUploaded": "Đã upload label",
        "labelLinked": "Đã gắn link label",
        "emailPlaceholder": "name@example.com",
        "orderNameRequired": "Tên đơn hàng là bắt buộc — vui lòng nhập ở ô đầu trang (cạnh tiêu đề).",
        "labelRequired": "Vui lòng upload label ở bước Shipping (phương thức Label từ sàn).",
        "artworkCheckingRetry": "Đang kiểm tra yêu cầu artwork — vui lòng đợi giây lát rồi thử lại.",
        "artworkMissing": "Còn vùng in bắt buộc chưa có artwork: {{areas}}. Vui lòng quay lại bước Artwork để upload.",
        "updateOrderFailed": "Cập nhật đơn hàng thất bại",
        "createDraftFailed": "Tạo bản nháp thất bại",
        "wrongSize": "sai kích thước",
        "uploadArtworkFailed": "Upload artwork thất bại — thử lại.",
        "addressIncomplete": "Cần nhập: {{fields}}",
        "variantUnresolved": "Một số sản phẩm có biến thể không khớp với blueprint. Sản phẩm có thể đã được tạo với biến thể tạm — hãy tạo lại sản phẩm để lấy đúng Size/Màu từ blueprint."
      }
    },
    "cancel": {
      "qtyAria": "Số lượng {{productName}} cần huỷ"
    },
    "tracking": {
      "openAria": "Mở theo dõi {{carrier}} trong tab mới"
    },
    "bulkDiscount": {
      "cta": "Tìm hiểu thêm"
    },
    "export": {
      "action": "Xuất"
    },
    "flash": {
      "paidStub": "Đã xác nhận thanh toán ở môi trường sandbox. Việc lưu đơn sẽ được hoàn thiện ở bước sau — bản nháp của bạn chưa hiển thị trong danh sách bên dưới.",
      "savedDraft": "Đơn hàng đã được lưu. Bạn có thể thanh toán sau từ trang chi tiết đơn."
    },
    "edit": {
      "review": {
        "saveAndPay": "Lưu thay đổi & tiếp tục thanh toán",
        "saveOnly": "Lưu thay đổi (thanh toán sau)"
      },
      "title": "Sửa đơn"
    },
    "status": {
      "draft": "Nháp",
      "unverified": "Chưa xác minh",
      "pending": "Chờ xử lý",
      "waitingApproval": "Chờ duyệt",
      "inProduction": "Đang sản xuất",
      "shipped": "Đã gửi",
      "delivered": "Đã giao",
      "cancelled": "Đã hủy",
      "issues": "Có vấn đề"
    },
    "timeline": {
      "new": "Mới",
      "approval": "Duyệt",
      "production": "Đang sản xuất",
      "shipped": "Đã gửi",
      "delivered": "Đã giao"
    },
    "activity": {
      "by": "bởi"
    },
    "sub": {
      "artworkNone": "Chưa có thiết kế",
      "artworkOk": "Thiết kế",
      "shipping": "Vận chuyển",
      "unit": "Đơn giá"
    },
    "checkout": {
      "cost": {
        "title": "Chi phí đơn hàng",
        "subtitle": "Cập nhật trực tiếp từ báo giá",
        "subtotal": "Tạm tính sản phẩm",
        "discount": "Giảm giá",
        "shipping": "Vận chuyển",
        "seasonal": "Phí mùa cao điểm",
        "tax": "Thuế",
        "tariff": "Thuế đối ứng (tariff)",
        "duty": "Thuế nhập khẩu (DDP)",
        "digitizing": "Phí digitizing",
        "rush": "Giao gấp (Rush)",
        "handling": "Phí xử lý",
        "embroidery": "Phí thêu",
        "embroideryPending": "Chờ digitize",
        "embroideryPendingTooltip": "Phí thêu tính theo số mũi — chốt sau khi digitize xong.",
        "embroideryExcluded": "Chưa gồm phí thêu (chờ digitize)",
        "empty": "Thêm sản phẩm để xem chi tiết chi phí.",
        "total": "Tổng cộng",
        "confirm": "Xác nhận & thanh toán",
        "confirming": "Đang xác nhận…",
        "disclaimer": "Báo giá chỉ mang tính tham khảo — giá chốt tại thời điểm xác nhận đơn.",
        "degradeTooltip": "Nhập địa chỉ giao hàng để tính phí theo vùng.",
        "error": {
          "title": "Không lấy được báo giá",
          "retry": "Thử lại"
        },
        "confirmBlocked": {
          "quoteFailed": "Không thể xác nhận — báo giá lại thất bại. Hãy thử lại.",
          "priceMissing": "Bỏ sản phẩm thiếu giá để tiếp tục.",
          "needsAddress": "Nhập địa chỉ giao hàng để có giá cuối cùng.",
          "noPrice": "Đang chờ giá thật từ hệ thống."
        }
      },
      "groups": {
        "title": "Nhóm vận chuyển",
        "subtitle": "Sản phẩm được gom thành các kiện theo nơi sản xuất và packing class.",
        "empty": "Chưa có nhóm vận chuyển — thêm sản phẩm vào giỏ.",
        "groupName": "Nhóm {{n}}",
        "itemCount": "{{count}} sản phẩm",
        "reasonTooltip": "Các sản phẩm này đóng chung một kiện — cùng nơi sản xuất và packing class.",
        "qtyLine": "Số lượng: {{count}}",
        "anchorBadge": "Neo",
        "anchorTooltip": "Sản phẩm neo — tính phí gói đầu tiên của nhóm.",
        "accessoryBadge": "Phụ kiện đi kèm",
        "accessoryTooltip": "Phụ kiện đi kèm — không tính thêm phí ship.",
        "serviceLabel": "Dịch vụ vận chuyển",
        "serviceOption": "{{label}} — {{price}}",
        "serviceOptionEta": "{{label}} — {{eta}} ngày — {{price}}",
        "degradeTooltip": "Nhập địa chỉ giao hàng để tính phí theo vùng.",
        "rush": {
          "title": "Giao gấp (Rush)",
          "desc": "Bật sẽ tính lại báo giá.",
          "descWithFee": "Cam kết sản xuất trong 48 giờ — có phí thêm. Bật sẽ tính lại báo giá.",
          "toggleAria": "Bật giao gấp"
        }
      },
      "priceDrift": {
        "title": "Giá đã thay đổi",
        "desc": "Một số khoản phí đã thay đổi so với báo giá bạn đang xem. Kiểm tra trước khi tiếp tục.",
        "col": {
          "item": "Khoản",
          "old": "Giá cũ",
          "new": "Giá mới",
          "total": "Tổng cộng"
        },
        "backToCart": "Quay lại giỏ hàng",
        "accept": "Chấp nhận giá mới",
        "confirming": "Đang xác nhận…"
      }
    },
    "orderType": {
      "bundle": "Combo"
    }
  },
  "stores": {
    "_comment": "Phase 6 Wave 8 Task 25 / Task 26 / Task 27 — Connect-store surface + Store detail page + cross-store sync surface (P6.D-107..114 / P6.D-202 / P6.D-112 / P6.D-223 / P6.D-237 / G-41..G-45).",
    "list": {
      "title": "Cửa hàng",
      "subtitle": "Quản lý các cửa hàng thương mại điện tử đã kết nối"
    },
    "filter": {
      "platform": {
        "label": "Nền tảng",
        "all": "Tất cả nền tảng"
      },
      "status": {
        "label": "Trạng thái",
        "all": "Tất cả trạng thái"
      }
    },
    "view": {
      "grid": "Lưới",
      "list": "Danh sách"
    },
    "connectNew": "Kết nối cửa hàng mới",
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "amazon": "Amazon",
      "tiktok": "TikTok Shop",
      "woocommerce": "WooCommerce",
      "manual": "Thủ công"
    },
    "empty": {
      "title": "Chưa có cửa hàng kết nối",
      "subtitle": "Kết nối cửa hàng đầu tiên để đồng bộ sản phẩm và đơn hàng.",
      "cta": "Kết nối cửa hàng đầu tiên"
    },
    "kpi": {
      "activeStores": "Cửa hàng hoạt động",
      "productsSynced": "Tổng sản phẩm",
      "totalOrders": "Đơn chờ xử lý"
    },
    "card": {
      "productCount": "{{count}} sản phẩm",
      "lastSync": "Đồng bộ gần nhất {{time}}",
      "menu": {
        "syncNow": "Đồng bộ ngay",
        "view": "Xem",
        "disconnect": "Ngắt kết nối"
      },
      "orders": "Đơn hàng",
      "products": "Sản phẩm",
      "settings": "Cài đặt",
      "sync": "Đồng bộ",
      "syncFailed": "Không thể bắt đầu đồng bộ",
      "syncQueued": "Đã bắt đầu đồng bộ",
      "code": "Store code (dùng cho bulk import)",
      "statusLabel": {
        "active": "Đã kết nối",
        "paused": "Tạm dừng",
        "disconnected": "Lỗi",
        "pending": "Chờ xử lý"
      }
    },
    "syncLogs": {
      "aggregation": {
        "title": "Nhật ký đồng bộ",
        "filter": {
          "platform": "Nền tảng",
          "store": "Cửa hàng"
        },
        "column": {
          "store": "Cửa hàng"
        },
        "allPlatforms": "Tất cả nền tảng",
        "allStatuses": "Tất cả trạng thái",
        "allStores": "Tất cả cửa hàng",
        "allTypes": "Tất cả loại"
      },
      "allStores": "Tất cả cửa hàng",
      "allPlatforms": "Tất cả nền tảng",
      "allTypes": "Tất cả loại",
      "allStatuses": "Tất cả trạng thái"
    },
    "externalProducts": {
      "title": "Sản phẩm bên ngoài",
      "editMapping": "Sửa map",
      "empty": "Chưa có sản phẩm bên ngoài nào.",
      "filter": {
        "all": "Tất cả",
        "mapped": "Đã map",
        "unmapped": "Chưa map",
        "review": "Cần kiểm tra"
      },
      "column": {
        "title": "Tên sản phẩm",
        "sku": "SKU bên ngoài",
        "mapped": "Sản phẩm Printway",
        "lastSync": "Đồng bộ gần nhất"
      }
    },
    "disconnect": {
      "title": "Ngắt kết nối store",
      "banner": "Bạn sắp ngắt kết nối store {{name}}",
      "consequences": {
        "h": "Khi ngắt kết nối:"
      },
      "consequence": {
        "ordersKeep": "Đơn hàng cũ giữ nguyên",
        "noNewSync": "Không sync đơn/sản phẩm mới",
        "productsKept": "Sản phẩm đã import giữ — sửa thủ công",
        "canReconnect": "Có thể kết nối lại bất kỳ lúc nào"
      },
      "reasonLabel": "Lý do (tuỳ chọn)",
      "reasonOptional": "— Chọn lý do (không bắt buộc) —",
      "reason": {
        "switchingPlatform": "Đổi nền tảng khác",
        "closingStore": "Đóng store",
        "troubleshooting": "Khắc phục sự cố",
        "other": "Khác"
      },
      "confirmType": "Gõ \"disconnect\" để xác nhận",
      "confirmBtn": "Ngắt kết nối",
      "reconnectBtn": "Kết nối lại",
      "successToast": "Đã ngắt kết nối store.",
      "success": "Đã ngắt kết nối cửa hàng."
    },
    "syncSettings": {
      "advanced": {
        "title": "Cài đặt sync nâng cao"
      },
      "resources": {
        "h": "Tài nguyên đồng bộ"
      },
      "resource": {
        "products": "Sản phẩm",
        "orders": "Đơn hàng",
        "inventory": "Tồn kho",
        "customers": "Khách hàng"
      },
      "retryPolicy": "Chính sách thử lại",
      "retry": {
        "immediate": "Ngay lập tức",
        "exponential": "Tăng dần (exponential)",
        "fixed_interval": "Khoảng cố định"
      },
      "maxRetries": "Số lần thử lại tối đa",
      "alertEmail": "Email cảnh báo",
      "syncWindow": "Khung giờ đồng bộ",
      "windowStart": "Bắt đầu",
      "windowEnd": "Kết thúc",
      "windowTz": "Múi giờ",
      "pause": "Tạm dừng đồng bộ",
      "resume": "Tiếp tục đồng bộ"
    },
    "syncOrders": {
      "title": "Đồng bộ đơn hàng",
      "narrow": "Đồng bộ giới hạn",
      "sinceDate": "Từ ngày",
      "specificOrder": "Đơn cụ thể",
      "runNarrow": "Chạy đồng bộ giới hạn",
      "jobStatus": "Job đang xử lý: {{jobId}}"
    },
    "syncProducts": {
      "title": "Đồng bộ sản phẩm",
      "narrow": "Đồng bộ giới hạn",
      "skuPrefix": "Tiền tố SKU",
      "oosOnly": "Chỉ hết hàng",
      "runNarrow": "Chạy đồng bộ giới hạn",
      "jobStatus": "Job đang xử lý: {{jobId}}"
    },
    "status": {
      "active": "Đang hoạt động",
      "paused": "Tạm dừng",
      "disconnected": "Đã ngắt kết nối",
      "pending": "Đang chờ"
    },
    "detail": {
      "_comment": "Phase 6 Wave 8 Task 26 — Store detail page tabs.",
      "back": "Quay lại danh sách store",
      "loadError": "Không tải được thông tin store",
      "notFound": "Không tìm thấy store này",
      "actions": "Hành động",
      "tabsAriaLabel": "Các tab quản lý store",
      "disconnectTitle": "Ngắt kết nối store?",
      "disconnectBody": "Bạn sắp ngắt kết nối {{name}}. Toàn bộ đồng bộ tự động sẽ dừng. Bạn có thể kết nối lại sau.",
      "disconnectInProgress": "Đang ngắt kết nối…",
      "tab": {
        "overview": "Tổng quan",
        "mapping": "Trung tâm mapping",
        "syncLogs": "Nhật ký đồng bộ",
        "settings": "Cài đặt"
      },
      "action": {
        "syncProducts": "Đồng bộ sản phẩm",
        "syncOrders": "Đồng bộ đơn hàng",
        "disconnect": "Ngắt kết nối"
      },
      "toast": {
        "syncProductsQueued": "Đã xếp hàng đồng bộ sản phẩm.",
        "syncOrdersQueued": "Đã xếp hàng đồng bộ đơn hàng.",
        "syncFailed": "Không thể bắt đầu đồng bộ. Vui lòng thử lại.",
        "disconnectFailed": "Không thể ngắt kết nối. Vui lòng thử lại."
      },
      "kpi": {
        "connectedSince": "Kết nối từ",
        "totalProducts": "Tổng sản phẩm",
        "totalOrders": "Tổng đơn hàng",
        "revenue30d": "Doanh thu 30 ngày",
        "lastSync": "Đồng bộ gần nhất",
        "syncStatus": "Trạng thái đồng bộ"
      },
      "health": {
        "label": "Tình trạng:",
        "healthy": "Khỏe mạnh",
        "warning": "Cần kiểm tra",
        "disconnected": "Đã ngắt kết nối"
      },
      "recentActivity": "Hoạt động đồng bộ gần đây",
      "viewAllLogs": "Xem toàn bộ nhật ký",
      "noActivity": "Chưa có hoạt động đồng bộ nào.",
      "recordsCount": "{{count}} bản ghi",
      "mapping": {
        "title": "Trung tâm mapping",
        "filterAriaLabel": "Bộ lọc mapping",
        "filter": {
          "all": "Tất cả",
          "unmapped": "Chưa map",
          "high-confidence": "Tin cậy cao (>85%)",
          "review": "Cần kiểm tra"
        },
        "batchConfirm": "Xác nhận hàng loạt (tin cậy cao)",
        "batchConfirmDone": "Đã xác nhận {{count}} dòng.",
        "saveDone": "Đã lưu mapping.",
        "unmappedFilter": "Chưa map",
        "highConfidence": "Tin cậy cao",
        "confidence": "Độ tin cậy",
        "noScore": "Chưa có",
        "statusReview": "Cần kiểm tra",
        "statusUnmapped": "Chưa map",
        "edit": "Sửa",
        "editTitle": "Sửa mapping sản phẩm",
        "productIdLabel": "Mã sản phẩm Printway",
        "productIdPlaceholder": "Nhập product/variant ID…",
        "suggestionLabel": "Gợi ý",
        "totalRows": "{{count}} dòng",
        "empty": "Không có sản phẩm nào trong bộ lọc này.",
        "column": {
          "externalSku": "SKU bên ngoài",
          "externalTitle": "Tên sản phẩm",
          "mappedProduct": "Sản phẩm Printway",
          "confidence": "Độ tin cậy",
          "action": "Hành động"
        }
      },
      "syncLogs": {
        "empty": "Không có nhật ký đồng bộ.",
        "retry": "Thử lại",
        "retryQueued": "Đã xếp hàng chạy lại.",
        "pageOf": "Trang {{page}} / {{total}}",
        "filter": {
          "type": "Loại",
          "status": "Trạng thái",
          "from": "Từ ngày",
          "to": "Đến ngày",
          "allTypes": "Tất cả loại",
          "allStatuses": "Tất cả trạng thái"
        },
        "type": {
          "products": "Sản phẩm",
          "orders": "Đơn hàng",
          "inventory": "Tồn kho"
        },
        "status": {
          "success": "Thành công",
          "partial": "Một phần",
          "failed": "Thất bại"
        },
        "column": {
          "timestamp": "Thời điểm",
          "type": "Loại",
          "status": "Trạng thái",
          "records": "Bản ghi",
          "duration": "Thời lượng",
          "action": "Hành động"
        }
      },
      "settings": {
        "autoSyncProducts": "Tự đồng bộ sản phẩm",
        "autoSyncProductsHelp": "Tự động kéo sản phẩm về Printway.",
        "autoSyncOrders": "Tự đồng bộ đơn hàng",
        "autoSyncOrdersHelp": "Tự động kéo đơn hàng mới về Printway.",
        "syncInterval": "Khoảng thời gian đồng bộ",
        "intervalOption": "{{minutes}} phút",
        "webhookUrl": "Webhook URL",
        "webhookUrlPlaceholder": "Chưa có webhook",
        "fulfillmentPolicy": "Chính sách thực hiện đơn",
        "fulfillment": {
          "manual": "Thủ công",
          "auto": "Tự động",
          "review": "Cần duyệt"
        },
        "inventorySync": "Đồng bộ tồn kho",
        "inventorySyncHelp": "Đẩy số lượng tồn kho ngược lên platform.",
        "currency": "Tiền tệ",
        "save": "Lưu cài đặt",
        "saving": "Đang lưu…",
        "saveDone": "Đã lưu cài đặt.",
        "copyFailed": "Không thể sao chép. Vui lòng thử thủ công.",
        "dangerZone": "Vùng nguy hiểm",
        "dangerZoneBody": "Ngắt kết nối store sẽ dừng mọi hoạt động đồng bộ tự động.",
        "disconnect": "Ngắt kết nối store",
        "disconnectConfirm": "Bạn chắc chắn muốn ngắt kết nối store này?",
        "approvalTime": "Thời gian duyệt đơn",
        "approvalTimeHelp": "Khoảng chờ sau khi đơn được đồng bộ trước khi tự đẩy sang sản xuất. Bật 'Tự đồng bộ đơn' để dùng.",
        "approvalTimeOption": {
          "immediate": "Ngay lập tức",
          "30m": "Sau 30 phút",
          "1h": "Sau 1 giờ",
          "4h": "Sau 4 giờ"
        }
      },
      "codeLabel": "Mã",
      "rename": {
        "required": "Tên cửa hàng là bắt buộc.",
        "success": "Đã đổi tên cửa hàng.",
        "failed": "Không thể đổi tên cửa hàng.",
        "edit": "Sửa tên cửa hàng"
      },
      "code": "Store code (dùng cho bulk import)"
    },
    "connect": {
      "title": "Kết nối store",
      "subtitle": "Chọn nền tảng để kết nối store của bạn.",
      "platform": {
        "shopify": "Shopify",
        "shopifyDesc": "Kết nối qua OAuth bằng tên miền cửa hàng.",
        "woocommerce": "WooCommerce",
        "woocommerceDesc": "Kết nối bằng REST API key của WordPress.",
        "tiktok": "TikTok Shop",
        "tiktokDesc": "Kết nối TikTok Shop qua OAuth.",
        "etsy": "Etsy",
        "etsyDesc": "OAuth chính thức sắp ra mắt — dùng Chrome Extension bên dưới.",
        "amazon": "Amazon",
        "amazonDesc": "Tích hợp Amazon Seller chính thức sắp ra mắt.",
        "manual": "Store thủ công",
        "manualDesc": "Theo dõi store ngoài / độc lập theo cách thủ công.",
        "available": "Sẵn sàng",
        "comingSoon": "Sắp có"
      },
      "etsyExtension": "Dùng Chrome Extension cho Etsy",
      "shopify": {
        "title": "Kết nối Shopify",
        "subtitle": "Nhập tên miền Shopify để bắt đầu OAuth.",
        "domainLabel": "Tên miền Shopify",
        "connect": "Kết nối Shopify",
        "help": "Tìm trong Shopify admin → Settings → Domains. Chúng tôi sẽ chuyển bạn sang Shopify để cấp quyền.",
        "helpLink": "Tìm hiểu thêm",
        "invalidDomain": "Nhập tên miền Shopify hợp lệ (ví dụ: your-shop.myshopify.com).",
        "unknownError": "Không thể bắt đầu kết nối Shopify. Vui lòng thử lại.",
        "feat": {
          "inventory": {
            "subtitle": "Đồng bộ tồn kho thời gian thực trên các nền tảng",
            "title": "Quản lý tồn kho"
          },
          "orders": {
            "subtitle": "Đơn hàng chảy thẳng về dashboard của bạn",
            "title": "Tự động đồng bộ đơn"
          },
          "publish": {
            "subtitle": "Đăng sản phẩm trực tiếp lên Shopify",
            "title": "Đăng sản phẩm"
          }
        },
        "redirectNote": "Bạn sẽ được chuyển tới Shopify để cấp quyền truy cập cửa hàng.",
        "urlHeading": "Nhập URL cửa hàng Shopify",
        "urlHint": "Nhập domain myshopify.com của bạn"
      },
      "woo": {
        "title": "Kết nối WooCommerce",
        "subtitle": "Dán thông tin REST API của WooCommerce.",
        "urlLabel": "URL website",
        "keyLabel": "Consumer Key",
        "secretLabel": "Consumer Secret",
        "connect": "Kết nối WooCommerce",
        "helpTitle": "Tìm thông tin ở đâu",
        "help1": "WP Admin → WooCommerce → Settings → Advanced → REST API.",
        "help2": "Nhấn “Add key”, đặt quyền Read/Write rồi Generate API key.",
        "help3": "Sao chép Consumer Key + Consumer Secret vào đây.",
        "invalidUrl": "Nhập URL HTTPS hợp lệ (ví dụ: https://shop.example.com).",
        "missingCreds": "Cần điền cả Consumer Key và Consumer Secret.",
        "successToast": "Đã kết nối store WooCommerce.",
        "unknownError": "Không thể kết nối WooCommerce. Hãy kiểm tra lại thông tin và thử lại.",
        "credsHeading": "Nhập thông tin API",
        "credsHelp": "Tạo khoá REST API quyền Đọc/Ghi trong trang quản trị WooCommerce và dán vào đây.",
        "feat": {
          "inventory": {
            "subtitle": "Đồng bộ tồn kho thời gian thực trên các nền tảng",
            "title": "Quản lý tồn kho"
          },
          "orders": {
            "subtitle": "Đơn hàng chảy thẳng về dashboard của bạn",
            "title": "Tự động đồng bộ đơn"
          },
          "publish": {
            "subtitle": "Đăng sản phẩm trực tiếp lên WooCommerce",
            "title": "Đăng sản phẩm"
          }
        },
        "step": {
          "creds": "Thông tin API",
          "url": "URL cửa hàng",
          "verify": "Xác minh kết nối"
        },
        "urlHeading": "Nhập URL cửa hàng của bạn",
        "urlHelp": "Nhập URL chính của cửa hàng WooCommerce. Hãy chắc chắn cửa hàng đã cài và kích hoạt WooCommerce.",
        "urlHint": "Nhập URL đầy đủ bao gồm https://",
        "verifying": "Đang xác minh kết nối…",
        "verifyingHelp": "Đang kiểm tra URL cửa hàng và thông tin REST API."
      },
      "tiktok": {
        "title": "Kết nối TikTok Shop",
        "subtitle": "Cấp quyền cho Printway quản lý sản phẩm và đơn hàng trên TikTok Shop.",
        "connect": "Kết nối TikTok",
        "helpTitle": "Cách thức hoạt động",
        "help1": "Nhấn Kết nối để mở TikTok Shop trong cửa sổ mới.",
        "help2": "Đăng nhập tài khoản người bán bạn muốn liên kết.",
        "help3": "Chấp nhận các quyền được yêu cầu rồi quay lại đây.",
        "unknownError": "Không thể bắt đầu kết nối TikTok Shop. Vui lòng thử lại.",
        "access": {
          "inventory": "Tồn kho - Giữ đồng bộ",
          "orders": "Đơn hàng - Tự động đồng bộ",
          "products": "Sản phẩm - Đăng và quản lý"
        },
        "accessIntro": "Bạn sẽ được chuyển tới TikTok để cấp quyền kết nối. Chúng tôi sẽ truy cập:",
        "feat": {
          "analytics": {
            "subtitle": "Theo dõi hiệu suất bán hàng và xu hướng từ dashboard của bạn",
            "title": "Phân tích & Thông tin chi tiết"
          },
          "connect": {
            "subtitle": "Kết nối TikTok Shop bằng một cú nhấp qua OAuth",
            "title": "Kết nối cửa hàng liền mạch"
          },
          "orders": {
            "subtitle": "Đơn hàng chảy thẳng về dashboard Printway của bạn",
            "title": "Tự động đồng bộ đơn"
          },
          "publish": {
            "subtitle": "Đăng sản phẩm POD trực tiếp lên TikTok Shop",
            "title": "Đăng sản phẩm"
          }
        },
        "redirectNote": "Bạn sẽ được chuyển tới TikTok để cấp quyền kết nối. Hãy chắc chắn bạn đã đăng nhập tài khoản người bán TikTok Shop.",
        "req1": "Tài khoản người bán TikTok Shop đang hoạt động",
        "req2": "Cửa hàng phải được duyệt và đang hoạt động tốt",
        "req3": "Đã hoàn tất xác minh doanh nghiệp",
        "reqTitle": "Yêu cầu:",
        "viaTitle": "Kết nối qua TikTok"
      },
      "callback": {
        "processing": "Đang xử lý...",
        "processingDetail": "Đang xác thực kết nối với nền tảng.",
        "errorTitle": "Kết nối thất bại",
        "error": "Kết nối thất bại — thử lại",
        "missingParams": "Thiếu tham số OAuth. Vui lòng thử lại kết nối.",
        "invalidPlatform": "URL callback không hỗ trợ nền tảng này.",
        "expiredState": "Liên kết kết nối đã hết hạn hoặc đã sử dụng. Vui lòng thử lại.",
        "successToast": "Đã kết nối store thành công.",
        "backToConnect": "Quay lại kết nối"
      },
      "placeholder": {
        "shopifyDomain": "cua-hang-cua-ban.myshopify.com",
        "wooUrl": "cua-hang-cua-ban.com"
      },
      "platformDescription": {
        "shopify": "Kết nối cửa hàng Shopify của bạn để đồng bộ sản phẩm và đơn hàng",
        "etsy": "Kết nối cửa hàng Etsy của bạn để đồng bộ sản phẩm và đơn hàng",
        "woocommerce": "Kết nối cửa hàng WooCommerce của bạn để đồng bộ sản phẩm và đơn hàng",
        "tiktok": "Kết nối TikTok Shop của bạn để tiếp cận hàng triệu người mua sắm",
        "manual": "Tạo cửa hàng thủ công — không cần tài khoản nền tảng nào"
      },
      "backToPlatforms": "Quay lại danh sách nền tảng",
      "comingSoon": "Sắp ra mắt",
      "connect": "Kết nối",
      "connectedToast": "Đã kết nối cửa hàng",
      "encryptedNote": "Thông tin đăng nhập của bạn được mã hoá và lưu trữ an toàn",
      "etsy": {
        "extensionNote": "OAuth Etsy gốc sắp ra mắt — hãy dùng Printway Chrome Extension để nhập shop Etsy của bạn ngay hôm nay.",
        "title": "Kết nối Etsy"
      },
      "genericError": "Không thể kết nối cửa hàng. Vui lòng thử lại.",
      "integrationGuide": "Hướng dẫn tích hợp",
      "manual": {
        "create": "Tạo cửa hàng",
        "feat": {
          "fulfil": {
            "subtitle": "Định tuyến đơn thủ công qua sản xuất Printway",
            "title": "Sản xuất hợp nhất"
          },
          "track": {
            "subtitle": "Ghi nhận đơn từ cửa hàng offline / độc lập",
            "title": "Nhập đơn thủ công"
          }
        },
        "nameLabel": "Tên cửa hàng",
        "namePlaceholder": "Cửa hàng độc lập của tôi",
        "nameRequired": "Tên cửa hàng là bắt buộc.",
        "nameTooLong": "Tên cửa hàng tối đa 120 ký tự.",
        "subtitle": "Theo dõi cửa hàng offline hoặc độc lập theo tên. Không cần kết nối nền tảng.",
        "successToast": "Đã tạo cửa hàng thủ công.",
        "title": "Thêm cửa hàng thủ công",
        "unknownError": "Không thể tạo cửa hàng. Vui lòng thử lại."
      },
      "modalSubtitle": "Chọn nền tảng để kết nối cửa hàng của bạn:",
      "modalTitle": "Kết nối cửa hàng",
      "needHelp": "Cần trợ giúp?",
      "newBadge": "Mới",
      "selected": "Đã chọn",
      "whatYouGet": "Bạn sẽ nhận được:",
      "connectWith": "Kết nối với {{name}}"
    },
    "integrationGuide": {
      "backToStores": "Quay lại cửa hàng",
      "title": "Hướng dẫn tích hợp",
      "subtitle": "Soạn hướng dẫn kết nối theo từng bước hiển thị cho người bán đối với mỗi nền tảng.",
      "platformTablist": "Nền tảng",
      "emptyState": "Chưa có bước nào. Thêm bước đầu tiên cho nền tảng này.",
      "stepTitlePlaceholder": "Tiêu đề bước",
      "stepBodyPlaceholder": "Hướng dẫn cho bước…",
      "deleteStep": "Xóa bước",
      "addStep": "Thêm bước",
      "autosaveNote": "Các thay đổi được tự động lưu vào trình duyệt này. Kết nối một endpoint backend để xuất bản hướng dẫn cho tất cả người bán."
    },
    "sync": {
      "orderNoPlaceholder": "#1234"
    },
    "connectCard": {
      "subtitle": "để bắt đầu bán hàng",
      "title": "Kết nối cửa hàng mới"
    },
    "search": {
      "placeholder": "Tìm cửa hàng theo tên hoặc mã…",
      "label": "Tìm cửa hàng",
      "clear": "Xoá tìm kiếm",
      "noResults": {
        "title": "Không tìm thấy cửa hàng nào",
        "subtitle": "Thử đổi từ khoá tìm kiếm hoặc bỏ bớt bộ lọc."
      }
    },
    "table": {
      "col": {
        "store": "Cửa hàng",
        "status": "Trạng thái",
        "products": "Sản phẩm",
        "orders": "Đơn hàng",
        "lastSync": "Đồng bộ gần nhất"
      }
    },
    "settings": {
      "autoPush": {
        "label": "Chế độ tự động đẩy đơn",
        "help": "Thời gian chờ sau khi đơn đồng bộ trước khi tự động gửi vào sản xuất.",
        "mode": {
          "immediate": "Ngay lập tức",
          "30m": "Sau 30 phút",
          "1h": "Sau 1 giờ",
          "4h": "Sau 4 giờ",
          "12h": "Sau 12 giờ",
          "24h": "Sau 24 giờ",
          "48h": "Sau 48 giờ",
          "custom": "Tùy chỉnh thời gian chờ",
          "manual": "Thủ công (tự gửi từng đơn)"
        },
        "customMinutesLabel": "Thời gian chờ tùy chỉnh (phút)",
        "customMinutesHelp": "Nhập thời gian chờ từ 1 đến {{max}} phút (tối đa 72 giờ).",
        "customMinutesPlaceholder": "ví dụ: 120",
        "customMinutesSuffix": "phút",
        "save": "Lưu chế độ tự động đẩy đơn",
        "saving": "Đang lưu…",
        "success": "Đã cập nhật thiết lập tự động đẩy đơn.",
        "error": "Không thể cập nhật thiết lập tự động đẩy đơn. Vui lòng thử lại.",
        "errors": {
          "invalidMode": "Vui lòng chọn chế độ tự động đẩy đơn hợp lệ.",
          "customRequired": "Vui lòng nhập thời gian chờ tùy chỉnh (phút).",
          "customBounds": "Thời gian chờ tùy chỉnh phải từ 1 đến 4320 phút (72 giờ)."
        }
      }
    }
  },
  "wallet": {
    "_comment": "Phase 6 Wave 9 Task 28 — Wallet overview surface (KPI + Credit + Spending + Low-balance alert). vg-binding: PLAN:task-28 / P6.D-64 / P6.D-71..79 / G-46 / G-47",
    "overview": {
      "nav": {
        "label": "Ví"
      },
      "title": "Ví tổng quan",
      "kpi": {
        "balance": "Số dư",
        "creditLimit": "Hạn mức credit",
        "creditUsed": "Đã dùng credit",
        "pendingTopups": "Topup chờ",
        "monthlySpending": "Chi tháng"
      },
      "credit": {
        "title": "Credit (hạn mức)",
        "limit": "Hạn mức",
        "used": "Đã dùng",
        "outstanding": "Nợ hiện tại",
        "lifetimeUsed": "Tổng đã dùng",
        "available": "Còn lại",
        "expiry": "Hết hạn",
        "expiryWarn": "Sắp hết hạn ({{days}} ngày)",
        "usedHigh": "Đã dùng > 80%",
        "flow": {
          "explain": "Trừ Balance trước. Khi thiếu, dùng Credit. Balance tăng → tự trả Credit."
        },
        "blocked": {
          "limit": "Đã hết hạn mức Credit — không thể tạo đơn",
          "expired": "Credit đã hết hạn — không thể dùng"
        }
      },
      "spending": {
        "title": "Chi tiêu",
        "totalSpent": "Tổng đã chi",
        "averageDaily": "Trung bình/ngày",
        "empty": "Chưa có dữ liệu chi tiêu.",
        "range": {
          "7d": "7 ngày",
          "30d": "30 ngày",
          "90d": "90 ngày",
          "custom": "Tuỳ chọn"
        },
        "category": {
          "orderCharge": "Đơn hàng",
          "topup": "Nạp tiền",
          "refund": "Hoàn tiền",
          "creditCharge": "Trừ credit",
          "creditRepay": "Trả credit",
          "sendOut": "Chuyển đi",
          "receiveIn": "Nhận về",
          "cashback": "Hoàn tiền KM",
          "gatewayFee": "Phí gateway"
        }
      },
      "lowBalance": {
        "title": "Số dư thấp",
        "message": "Số dư hiện {{balance}} — dưới ngưỡng {{threshold}}. Nạp thêm để tránh gián đoạn.",
        "cta": "Nạp ngay",
        "dismiss": "Đóng"
      },
      "action": {
        "topup": "Nạp tiền",
        "withdraw": "Rút tiền",
        "transfer": "Chuyển"
      },
      "tab": {
        "overview": "Tổng quan",
        "transactions": "Giao dịch",
        "linkedAccounts": "Tài khoản liên kết",
        "bankAccounts": "Tài khoản ngân hàng",
        "topup": "Nạp tiền",
        "withdraw": "Rút tiền",
        "transactionsPlaceholder": "Danh sách giao dịch sẽ có ở Task 29.",
        "linkedAccountsPlaceholder": "Tài khoản liên kết sẽ có ở Task 31.",
        "bankAccountsPlaceholder": "Tài khoản ngân hàng sẽ có ở Task 31.",
        "navHint": "Chọn một tab phía trên để xem chi tiết."
      }
    },
    "topup": {
      "_comment": "Phase 6 Wave 9 Task 29 — Wallet topup (Instant + Manual + dual-mode + history). vg-binding: PLAN:task-29 / P6.D-66 / P6.D-67 / P6.D-68 / P6.D-234 / P6.D-244 / G-48",
      "title": "Nạp tiền",
      "confirm": "Xác nhận",
      "type": {
        "instant": {
          "label": "Tức thì",
          "desc": "Tiền vào ví ngay sau thanh toán"
        },
        "manual": {
          "label": "Thủ công",
          "desc": "Chuyển khoản ngân hàng + upload bằng chứng"
        }
      },
      "gateway": {
        "label": "Cổng thanh toán",
        "paypal": "PayPal",
        "stripe": "Stripe",
        "payoneer": "Payoneer",
        "lianlianGlobal": "LianLian Global",
        "bankTransfer": "Chuyển khoản",
        "pingpong": "Pingpong",
        "sunrate": "Sunrate",
        "worldfirst": "Worldfirst",
        "airwallex": "Airwallex"
      },
      "amount": {
        "label": "Số tiền",
        "invalid": "Số tiền không hợp lệ"
      },
      "fee": {
        "preview": "Phí gateway: {{fee}} ({{rate}}%)"
      },
      "dualMode": {
        "toggleLabel": "Chế độ",
        "feeCompare": "Phí Instant {{instant}}% / Manual {{manual}}%"
      },
      "manual": {
        "step": {
          "amount": "Số tiền",
          "invoice": "Hoá đơn",
          "proof": "Bằng chứng"
        },
        "payee": {
          "bankName": "Tên ngân hàng",
          "accountName": "Tên tài khoản",
          "accountNumber": "Số tài khoản",
          "swift": "SWIFT",
          "reference": "Mã tham chiếu",
          "address": "Địa chỉ",
          "missing": "Không có thông tin người nhận cho cổng này — hãy liên hệ hỗ trợ trước khi chuyển khoản."
        },
        "invoice": {
          "download": "Tải hoá đơn PDF",
          "unavailable": "Hoá đơn tạm tính (PDF) chưa hỗ trợ cho nạp tiền thủ công — vui lòng chuyển khoản theo thông tin người nhận ở trên."
        },
        "proof": {
          "upload": "Upload bằng chứng",
          "uploaded": "Đã upload — chờ xét duyệt",
          "missing": "Vui lòng chọn file"
        }
      },
      "history": {
        "title": "Lịch sử nạp tiền",
        "empty": "Chưa có giao dịch nạp tiền",
        "column": {
          "createdAt": "Thời điểm",
          "gateway": "Cổng",
          "mode": "Chế độ",
          "amount": "Số tiền",
          "status": "Trạng thái",
          "proof": "Bằng chứng",
          "action": "Hành động"
        },
        "status": {
          "pending": "Đang chờ",
          "processing": "Đang xử lý",
          "completed": "Hoàn tất",
          "failed": "Thất bại",
          "cancelled": "Đã huỷ"
        },
        "action": {
          "cancel": "Huỷ",
          "retry": "Thử lại",
          "viewProof": "Xem bằng chứng",
          "viewReceipt": "Biên lai"
        }
      },
      "sdk": {
        "paypalPlaceholder": "SDK PayPal Smart Buttons sẽ tải ở đây",
        "stripePlaceholder": "Biểu mẫu Stripe Elements sẽ tải ở đây"
      }
    },
    "transactions": {
      "_comment": "Phase 6 Wave 9 Task 30 — Sổ giao dịch ví (9 loại theo P6.D-65 + P6.D-233 phí gateway). vg-binding: PLAN:task-30 / P6.D-65 / P6.D-233 / G-49",
      "tabs": {
        "transaction": "Giao dịch",
        "orderTransaction": "Giao dịch theo đơn"
      },
      "orderTx": {
        "order": "Đơn hàng",
        "txId": "Mã giao dịch",
        "amount": "Số tiền",
        "surcharge": "Phụ phí",
        "kind": "Loại",
        "date": "Ngày",
        "method": "Phương thức",
        "note": "Ghi chú",
        "search": "Tìm theo mã đơn / mã giao dịch",
        "searchPlaceholder": "Mã đơn hoặc mã giao dịch…",
        "noMatch": "Không có giao dịch khớp tìm kiếm",
        "empty": "Chưa có giao dịch theo đơn"
      },
      "child": {
        "type": {
          "charge": "Trừ tiền",
          "refund": "Hoàn tiền",
          "surcharge": "Phụ phí"
        }
      },
      "title": "Giao dịch",
      "subtitle": "9 loại giao dịch — sổ ví",
      "empty": "Chưa có giao dịch",
      "totalCount": "{{count}} giao dịch",
      "type": {
        "orderCharge": "Đơn hàng",
        "topup": "Nạp tiền",
        "refund": "Hoàn tiền",
        "creditCharge": "Trừ credit",
        "creditRepay": "Trả credit",
        "sendOut": "Chuyển đi",
        "receiveIn": "Nhận về",
        "cashback": "Hoàn tiền KM",
        "gatewayFee": "Phí gateway"
      },
      "column": {
        "id": "Mã giao dịch",
        "ts": "Thời gian",
        "type": "Loại",
        "method": "Phương thức",
        "description": "Mô tả",
        "note": "Ghi chú",
        "amount": "Số tiền",
        "balance": "Số dư sau",
        "action": "Hành động",
        "status": "Trạng thái"
      },
      "method": {
        "wallet": "Ví",
        "credit": "Tín dụng",
        "bank": "Ngân hàng",
        "paypal": "PayPal",
        "payoneer": "Payoneer",
        "stripe": "Stripe"
      },
      "filter": {
        "fromDate": "Từ",
        "toDate": "Đến",
        "status": "Trạng thái",
        "allTypes": "Tất cả loại",
        "allStatuses": "Tất cả trạng thái",
        "searchId": "Mã giao dịch",
        "searchIdPlaceholder": "Nhập mã giao dịch…",
        "allMethods": "Tất cả phương thức",
        "custom": "Tùy chỉnh",
        "dateRange": "Khoảng thời gian",
        "last30d": "30 ngày qua",
        "last7d": "7 ngày qua",
        "search": "Tìm ghi chú",
        "searchPlaceholder": "Tìm…",
        "today": "Hôm nay",
        "method": "Phương thức"
      },
      "status": {
        "pending": "Đang chờ",
        "completed": "Hoàn tất",
        "failed": "Thất bại"
      },
      "action": {
        "viewReceipt": "Xem hoá đơn",
        "receiptError": "Không tải được hoá đơn"
      },
      "detail": {
        "gateway": "Cổng",
        "reference": "Tham chiếu"
      },
      "export": {
        "csv": "CSV",
        "excel": "Excel",
        "error": "Xuất file thất bại"
      },
      "perPage": "Mỗi trang",
      "sort": {
        "createdAt": "Sắp xếp theo ngày",
        "label": "Ngày",
        "asc": "↑",
        "desc": "↓"
      },
      "showing": "Hiển thị {{from}}-{{to}} / {{total}}",
      "showingPage": "Hiển thị {{from}}-{{to}}",
      "pageLabel": "Trang {{page}}",
      "children": {
        "error": "Không thể tải chi tiết đơn. Vui lòng thử lại.",
        "empty": "Không có đơn nào trong giao dịch này."
      },
      "grouped": {
        "orderCount": "${row.orderCount} đơn",
        "label_one": "Thanh toán {{count}} đơn",
        "label_other": "Thanh toán {{count}} đơn",
        "orderCount_one": "{{count}} đơn",
        "orderCount_other": "{{count}} đơn",
        "label": "Thanh toán cho {{count}} đơn"
      },
      "error": "Không thể tải lịch sử giao dịch. Vui lòng thử lại."
    },
    "send": {
      "_comment": "Phase 6 Wave 9 Task 30 — Wizard chuyển số dư (P6.D-69). vg-binding: PLAN:task-30 / P6.D-69 / G-49",
      "title": "Chuyển số dư",
      "confirm": "Xác nhận",
      "feeFree": "Miễn phí giữa các merchant Printway — không phí gateway.",
      "success": "Chuyển thành công",
      "recent": "Người nhận gần đây",
      "noRecipients": "Bạn chưa thuộc nhóm chuyển tiền nào. Hãy nhờ admin thêm bạn vào một nhóm.",
      "step": {
        "recipient": "Người nhận",
        "confirm": "Xác nhận",
        "amount": "Số tiền",
        "verify": "Xác minh"
      },
      "recipient": {
        "label": "Email người nhận",
        "pickLabel": "Người nhận (thành viên Nhóm chuyển tiền)",
        "placeholder": "Chọn người nhận…"
      },
      "amount": {
        "label": "Số tiền",
        "available": "Khả dụng: {{amount}}"
      },
      "note": {
        "label": "Ghi chú (tuỳ chọn)"
      },
      "error": {
        "selfSend": "Không thể chuyển cho chính mình",
        "emailRequired": "Bắt buộc nhập email người nhận",
        "notFound": "Không tìm thấy người nhận",
        "invalidAmount": "Số tiền không hợp lệ",
        "pickRecipient": "Vui lòng chọn người nhận",
        "generic": "Chuyển thất bại",
        "insufficientBalance": "Số tiền vượt quá số dư khả dụng của bạn",
        "amountOutOfRange": "Số tiền nằm ngoài hạn mức cho phép của nhóm chuyển tiền",
        "limitExceeded": "Đã vượt hạn mức chuyển tiền hằng tháng",
        "recipientIneligible": "Người nhận không đủ điều kiện nhận chuyển tiền",
        "walletFrozen": "Ví của bạn đang bị tạm khóa — không thể chuyển tiền"
      }
    },
    "withdraw": {
      "_comment": "Phase 6 Wave 9 Task 30 — Trang + modal rút tiền. vg-binding: PLAN:task-30 / G-50",
      "title": "Rút tiền",
      "subtitle": "Yêu cầu rút từ ví về tài khoản ngân hàng",
      "bankAccount": "Tài khoản ngân hàng",
      "amount": "Số tiền",
      "feePreview": "Phí",
      "netAmount": "Thực nhận",
      "estimatedArrival": "Dự kiến nhận",
      "confirm": "Xác nhận rút",
      "request": "Yêu cầu rút tiền",
      "availableBalance": "Số dư khả dụng",
      "empty": "Chưa có tài khoản ngân hàng đã xác minh. Thêm trong Cài đặt.",
      "success": "Đã gửi yêu cầu rút tiền",
      "successWithEta": "Đã gửi yêu cầu rút — dự kiến nhận {{eta}}",
      "error": {
        "exceedsBalance": "Số tiền vượt quá số dư khả dụng",
        "noAccount": "Vui lòng chọn tài khoản",
        "generic": "Rút tiền thất bại"
      }
    },
    "transfer": {
      "_comment": "Phase 6 Wave 9 Task 30 — Modal chuyển giữa các tài khoản liên kết. vg-binding: PLAN:task-30 / G-50",
      "title": "Chuyển khoản",
      "from": "Từ",
      "to": "Đến",
      "amount": "Số tiền",
      "confirm": "Xác nhận chuyển",
      "selectAccount": "Chọn tài khoản",
      "error": {
        "required": "Chọn tài khoản nguồn và đích",
        "sameAccount": "Tài khoản nguồn và đích phải khác nhau",
        "invalidAmount": "Số tiền không hợp lệ",
        "generic": "Chuyển khoản thất bại"
      }
    },
    "twoFA": {
      "_comment": "Phase 6 Wave 9 Task 30 — Thử thách 2FA dùng chung cho Send + Withdraw + Transfer. vg-binding: PLAN:task-30 / P6.D-69",
      "title": "Xác minh 2FA",
      "code": "Mã 6 số",
      "verify": "Xác minh",
      "error": "Mã không hợp lệ"
    },
    "linkedAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Quản lý tài khoản liên kết (Send Balance quick-list). vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Tài khoản liên kết",
      "subtitle": "Danh sách nhanh các merchant Printway bạn có thể chuyển tiền.",
      "add": "Thêm liên kết",
      "empty": "Chưa có tài khoản liên kết",
      "deleteConfirm": "Xoá liên kết với {{email}}?",
      "deleteSuccess": "Đã xoá liên kết",
      "deleteError": "Không thể xoá liên kết",
      "addSuccess": "Đã thêm tài khoản liên kết",
      "modal": {
        "email": "Email người nhận",
        "lookup": {
          "match": "Tìm thấy: {{name}}",
          "notFound": "Không tìm thấy người dùng"
        },
        "errorEmailRequired": "Vui lòng nhập email",
        "errorSelfLink": "Không thể tự liên kết",
        "errorGeneric": "Không thể liên kết tài khoản",
        "add": "Thêm"
      }
    },
    "bankAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Quản lý tài khoản ngân hàng để rút tiền. vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Tài khoản ngân hàng",
      "subtitle": "Tài khoản đã xác thực có thể dùng để rút tiền.",
      "add": "Thêm tài khoản",
      "empty": "Chưa có tài khoản ngân hàng",
      "verified": "Đã xác thực",
      "notVerified": "Chưa xác thực",
      "deleteConfirm": "Xoá tài khoản này?",
      "deleteSuccess": "Đã xoá tài khoản",
      "deleteError": "Không thể xoá tài khoản",
      "addSuccessWithMask": "Đã thêm tài khoản {{mask}}",
      "field": {
        "bankName": "Tên ngân hàng",
        "accountName": "Tên chủ tài khoản",
        "accountNumber": "Số tài khoản",
        "accountType": "Loại tài khoản",
        "routingNumber": "Routing number",
        "country": "Quốc gia",
        "swift": "SWIFT / BIC",
        "iban": "IBAN",
        "address": "Địa chỉ Merchant",
        "addressStreet": "Địa chỉ (số nhà, đường)",
        "addressCity": "Thành phố",
        "addressState": "Bang / Tỉnh",
        "addressZip": "Mã bưu chính"
      },
      "accountType": {
        "checking": "Checking (thanh toán)",
        "savings": "Savings (tiết kiệm)"
      },
      "country": {
        "US": "Hoa Kỳ",
        "VN": "Việt Nam",
        "GB": "Anh",
        "FR": "Pháp",
        "DE": "Đức",
        "CN": "Trung Quốc",
        "JP": "Nhật Bản",
        "AU": "Úc",
        "CA": "Canada",
        "SG": "Singapore"
      },
      "modal": {
        "step": {
          "form": "Thông tin",
          "twoFA": "Xác minh 2FA"
        },
        "errorRequired": "Vui lòng điền đầy đủ thông tin bắt buộc",
        "errorGeneric": "Không thể thêm tài khoản",
        "add": "Thêm tài khoản"
      }
    },
    "pageTab": {
      "aria": "Mục ví",
      "overview": "Tổng quan",
      "billing": "Thanh toán",
      "invoices": "Hoá đơn",
      "transactions": "Giao dịch",
      "paymentMethods": "Phương thức thanh toán",
      "billingSettings": "Cài đặt thanh toán",
      "paymentRequests": "Yêu cầu thanh toán"
    },
    "recent": {
      "cancelError": "Không thể huỷ — hãy thử lại.",
      "title": "Giao dịch gần đây",
      "viewAll": "Xem tất cả →",
      "loading": "Đang tải…",
      "empty": "Chưa có giao dịch nào. Tạo topup hoặc withdraw để bắt đầu.",
      "cancel": "Huỷ",
      "col": {
        "description": "Nội dung",
        "date": "Thời gian",
        "amount": "Số tiền",
        "balanceAfter": "Số dư sau",
        "method": "Phương thức"
      },
      "pending": "Chờ duyệt"
    },
    "tx": {
      "orderCharge": "Thanh toán {{count}} đơn",
      "orderRefund": "Hoàn tiền {{count}} đơn",
      "transferIn": "Nhận tiền từ merchant",
      "transferOut": "Chuyển tiền tới merchant"
    }
  },
  "billing": {
    "_comment": "Phase 6 Wave 10 Task 32 — Billing standalone Finance entry. vg-binding: PLAN:task-32 / P6.D-01 / P6.D-245 / P6.D-247",
    "nav": {
      "label": "Hoá đơn"
    },
    "overview": {
      "title": "Tổng quan hoá đơn",
      "kpi": {
        "outstanding": "Còn nợ",
        "dueSoon": "Sắp đến hạn",
        "overdue": "Quá hạn"
      },
      "link": {
        "invoices": "Hoá đơn",
        "addresses": "Địa chỉ xuất hóa đơn",
        "paymentHistory": "Lịch sử thanh toán",
        "statements": "Sao kê",
        "paymentMethods": "Phương thức thanh toán"
      },
      "cta": {
        "create": "Tạo hoá đơn"
      },
      "mode": {
        "prepaid": {
          "subtext": "Bạn đang ở chế độ Trả trước. Hoá đơn ở đây chỉ để báo cáo."
        },
        "credit": {
          "subtext": "Bạn đang ở chế độ Credit. Hoá đơn ở đây chỉ để báo cáo."
        },
        "invoice": {
          "subtext": "Bạn đang ở chế độ Hoá đơn. Cần thanh toán đúng hạn để tránh quá hạn."
        }
      },
      "preview": {
        "viewAll": "Xem tất cả →",
        "empty": "Chưa có dữ liệu.",
        "statementSub": "Phí {{charges}} · Thanh toán {{payments}}",
        "default": "Mặc định"
      }
    },
    "list": {
      "title": "Danh sách hoá đơn",
      "column": {
        "invoiceNumber": "Số hoá đơn",
        "status": "Trạng thái",
        "issueDate": "Ngày phát hành",
        "dueDate": "Hạn thanh toán",
        "amount": "Số tiền",
        "actions": "Thao tác"
      },
      "filter": {
        "status": "Trạng thái",
        "all": "Tất cả",
        "draft": "Nháp",
        "pending": "Chờ thanh toán",
        "paid": "Đã thanh toán",
        "overdue": "Quá hạn",
        "cancelled": "Đã huỷ",
        "dateRange": "Kỳ thanh toán",
        "dateRangeHint": "Lọc theo kỳ mà hoá đơn tính tiền, không phải ngày phát hành.",
        "dateRangePlaceholder": "Từ ngày – Đến ngày"
      },
      "action": {
        "view": "Xem",
        "pay": "Thanh toán"
      },
      "empty": "Chưa có hoá đơn nào"
    },
    "status": {
      "draft": "Nháp",
      "pending": "Chờ thanh toán",
      "paid": "Đã thanh toán",
      "overdue": "Quá hạn",
      "cancelled": "Đã huỷ",
      "dueSoon": "Sắp đến hạn"
    },
    "create": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice CREATE page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Tạo hoá đơn",
      "field": {
        "customer": {
          "label": "Khách hàng",
          "placeholder": "Tên khách hàng"
        },
        "issueDate": "Ngày phát hành",
        "dueDate": "Hạn thanh toán",
        "lineItem": {
          "description": "Mô tả",
          "qty": "Số lượng",
          "unitPrice": "Đơn giá",
          "lineTotal": "Thành tiền"
        },
        "notes": "Ghi chú",
        "terms": "Điều khoản",
        "taxRate": "Thuế suất (%)",
        "email": "Email"
      },
      "terms": {
        "net7": "Net 7",
        "net15": "Net 15",
        "net30": "Net 30",
        "net60": "Net 60",
        "custom": "Tuỳ chỉnh",
        "customPlaceholder": "Điều khoản tùy chỉnh"
      },
      "lineItems": {
        "add": "Thêm dòng"
      },
      "section": {
        "lineItems": "Các dòng"
      },
      "subtotal": "Tạm tính",
      "creditApplied": "Tín dụng đã áp dụng",
      "tax": "Thuế",
      "total": "Tổng",
      "submit": "Tạo",
      "submitting": "Đang tạo...",
      "error": {
        "noLineItems": "Cần ít nhất một dòng",
        "generic": "Tạo hoá đơn thất bại"
      }
    },
    "detail": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice DETAIL page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Chi tiết hoá đơn",
      "empty": "Không tìm thấy hoá đơn",
      "action": {
        "pay": "Thanh toán",
        "downloadPdf": {
          "label": "Tải PDF",
          "loading": "Đang tải xuống..."
        },
        "downloadPdfLoading": "Đang tải...",
        "viewCustomer": "Xem khách hàng",
        "dispute": {
          "label": "Khiếu nại hoá đơn",
          "loading": "Đang mở khiếu nại..."
        }
      },
      "section": {
        "customer": "Khách hàng",
        "dates": "Ngày phát hành / Hạn",
        "lineItems": "Các dòng",
        "totals": "Tổng cộng",
        "notes": "Ghi chú",
        "payments": "Lịch sử thanh toán"
      },
      "lineItems": {
        "empty": "Chưa có dòng nào"
      },
      "payments": {
        "empty": "Chưa có thanh toán"
      },
      "pdf": {
        "notReadyTitle": "PDF chưa sẵn sàng",
        "notReady": "PDF hoá đơn đang được tạo. Vui lòng thử lại sau ít phút."
      },
      "dispute": {
        "subject": "Khiếu nại hoá đơn: #{{invoiceNumber}}",
        "body": "Merchant khiếu nại hoá đơn #{{invoiceNumber}}. Vui lòng kiểm tra các khoản phí và phản hồi.",
        "errorTitle": "Không mở được khiếu nại",
        "error": "Tạo ticket khiếu nại thất bại. Vui lòng thử lại."
      }
    },
    "pay": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice PAYMENT page. vg-binding: PLAN:task-33 / P6.D-241 / P6.D-245",
      "title": "Thanh toán hoá đơn",
      "summary": "Hoá đơn #{{number}} — Tổng {{amount}}",
      "confirm": "Xác nhận thanh toán",
      "processing": "Đang xử lý...",
      "success": "Thanh toán thành công",
      "error": "Lỗi thanh toán",
      "alreadyPaid": "Hoá đơn này đã được thanh toán — không trừ thêm tiền. Nếu ngân hàng hiển thị khoản tạm giữ, khoản đó sẽ tự huỷ.",
      "changed": "Hoá đơn đã thay đổi trong lúc thanh toán — chưa trừ tiền. Hãy kiểm tra lại rồi thử lại."
    },
    "paymentHistory": {
      "_comment": "Phase 6 Wave 10 Task 33 — Payment history page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Lịch sử thanh toán",
      "empty": "Chưa có thanh toán nào",
      "filter": {
        "from": "Từ",
        "to": "Đến",
        "method": {
          "label": "Phương thức",
          "all": "Tất cả",
          "wallet": "Ví",
          "stripe": "Stripe",
          "paypal": "PayPal",
          "bankTransfer": "Chuyển khoản"
        }
      },
      "column": {
        "ts": "Thời gian",
        "invoice": "Hoá đơn",
        "method": "Phương thức",
        "amount": "Số tiền",
        "status": "Trạng thái",
        "reference": "Mã tham chiếu",
        "action": "Thao tác"
      },
      "status": {
        "success": "Thành công",
        "pending": "Đang chờ",
        "failed": "Thất bại"
      },
      "action": {
        "viewReceipt": "Xem biên lai"
      }
    },
    "statements": {
      "_comment": "Phase 6 Wave 10 Task 33 — Statements page. vg-binding: PLAN:task-33 / P6.D-70",
      "title": "Sao kê",
      "empty": "Không có sao kê cho kỳ này",
      "period": {
        "label": "Kỳ",
        "daily": "Hàng ngày",
        "weekly": "Hàng tuần",
        "monthly": "Hàng tháng",
        "custom": "Tuỳ chỉnh"
      },
      "column": {
        "periodStart": "Bắt đầu kỳ",
        "periodEnd": "Kết thúc kỳ",
        "totalCharges": "Phát sinh",
        "totalPayments": "Thanh toán",
        "balance": "Số dư",
        "breakdown": "Phân loại theo danh mục"
      },
      "chart": {
        "title": "Phát sinh vs thanh toán"
      },
      "legend": {
        "charges": "Phát sinh",
        "payments": "Thanh toán"
      },
      "table": {
        "title": "Sao kê"
      },
      "download": "Tải sao kê",
      "noData": "Chưa có dữ liệu.",
      "breakdownEmpty": "Không có chi tiêu theo danh mục trong kỳ này"
    },
    "paymentMethods": {
      "_comment": "Phase 6 Wave 10 Task 34 — Payment methods management. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Phương thức thanh toán",
      "add": "Thêm phương thức",
      "empty": "Chưa lưu phương thức nào",
      "default": "Mặc định",
      "setDefault": "Đặt mặc định",
      "deleteConfirm": "Xoá phương thức này?",
      "last4": "•••• {{last4}}",
      "expiry": "Hạn {{month}}/{{year}}",
      "addSuccess": "Đã thêm phương thức",
      "deleteSuccess": "Đã xoá phương thức",
      "deleteError": "Xoá thất bại",
      "setDefaultSuccess": "Đã đặt mặc định",
      "setDefaultError": "Không thể đặt mặc định",
      "brand": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "Amex",
        "paypal": "PayPal",
        "card": "Thẻ"
      },
      "modal": {
        "subtitle": "Chọn nhà cung cấp và nhập thông tin",
        "tabsLabel": "Nhà cung cấp",
        "tabs": {
          "stripe": "Thẻ tín dụng (Stripe)",
          "paypal": "PayPal"
        },
        "cardNumber": "Số thẻ",
        "expDate": "Ngày hết hạn",
        "cvc": "Mã CVC",
        "holderName": "Tên chủ thẻ",
        "billingZip": "Mã bưu điện",
        "save": "Lưu",
        "connectPaypal": "Kết nối PayPal",
        "setDefault": "Đặt làm mặc định",
        "paypalSubtitle": "Kết nối tài khoản PayPal qua OAuth để dùng cho thanh toán hoá đơn.",
        "error": {
          "required": "Vui lòng điền đầy đủ thông tin thẻ",
          "generic": "Không thể thêm phương thức thanh toán",
          "cardDeclined": "Thẻ của bạn bị từ chối. Vui lòng thử thẻ khác.",
          "insufficientFunds": "Thẻ của bạn không đủ số dư.",
          "incorrectCvc": "Mã bảo mật của thẻ không đúng.",
          "expiredCard": "Thẻ của bạn đã hết hạn.",
          "processingError": "Có lỗi khi xử lý thẻ. Vui lòng thử lại.",
          "incompleteCard": "Vui lòng điền đầy đủ thông tin thẻ.",
          "authFailed": "Xác thực thẻ thất bại. Vui lòng thử lại.",
          "notConfigured": "Nền tảng chưa bật thanh toán bằng thẻ.",
          "network": "Không kết nối được với nhà cung cấp thanh toán. Vui lòng thử lại.",
          "duplicate": "Thẻ này đã được thêm trước đó."
        },
        "cardLoading": "Đang tải biểu mẫu thẻ bảo mật…",
        "cardUnavailable": "Hiện chưa thể thanh toán bằng thẻ. Vui lòng liên hệ hỗ trợ hoặc dùng PayPal.",
        "terms": "Thẻ của bạn được Stripe lưu trữ an toàn và dùng để thanh toán hoá đơn sau này. Bạn có thể gỡ bất cứ lúc nào."
      }
    },
    "fulfillmentReports": {
      "_comment": "Phase 6 Wave 10 Task 34 — Fulfillment reports list + generate. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Báo cáo thực hiện đơn",
      "generate": "Tạo báo cáo mới",
      "empty": "Chưa có báo cáo nào",
      "column": {
        "period": "Kỳ báo cáo",
        "totalOrders": "Tổng đơn hoàn thành",
        "totalRevenue": "Tổng doanh thu",
        "status": "Trạng thái",
        "generatedAt": "Tạo lúc",
        "download": "Tải về"
      },
      "status": {
        "generating": "Đang tạo",
        "ready": "Sẵn sàng",
        "failed": "Thất bại"
      },
      "download": {
        "pdf": "PDF",
        "csv": "CSV"
      },
      "generate.title": "Tạo báo cáo thực hiện đơn",
      "generate.period.label": "Kỳ báo cáo",
      "generate.period.last7d": "7 ngày gần nhất",
      "generate.period.last30d": "30 ngày gần nhất",
      "generate.period.last90d": "90 ngày gần nhất",
      "generate.period.custom": "Tuỳ chỉnh",
      "generate.storeFilter": "Lọc theo cửa hàng (id, ngăn cách bằng dấu phẩy)",
      "generate.categoryFilter": "Lọc theo danh mục sản phẩm (id, ngăn cách bằng dấu phẩy)",
      "generate.submit": "Tạo",
      "generate.processing": "Đang tạo... ({{pct}}%)",
      "generate.error.dateRequired": "Cần chọn ngày bắt đầu và kết thúc",
      "generate.error.generic": "Tạo báo cáo thất bại"
    }
  },
  "settings": {
    "_comment": "Phase 6 Wave 11 Task 35 — Cài đặt (Hồ sơ + Tổng quát + Hoạt động). vg-binding: PLAN:task-35 / P6.D-122 / P6.D-123 / P6.D-131 / P6.D-132 / P6.D-221 / P6.D-249 / G-57 / G-69",
    "nav": {
      "label": "Cài đặt"
    },
    "savedAt": "Đã lưu lúc {{ts}}",
    "tab": {
      "profile": "Hồ sơ",
      "security": "Bảo mật",
      "notifications": "Thông báo",
      "preferences": "Tuỳ chọn",
      "activity": "Hoạt động",
      "general": "Tổng quát",
      "team": "Đội ngũ",
      "branding": "Thương hiệu",
      "apiKeys": "Khoá API",
      "connections": "Kết nối",
      "security.placeholder": "Cài đặt bảo mật — sắp ra mắt.",
      "notifications.placeholder": "Cài đặt thông báo — sắp ra mắt.",
      "preferences.placeholder": "Cài đặt tuỳ chọn — sắp ra mắt."
    },
    "profile": {
      "title": "Hồ sơ",
      "avatar": "Tải ảnh đại diện",
      "name": "Tên hiển thị",
      "email": "Email",
      "email.readonly": "Liên hệ Hỗ trợ để đổi email.",
      "phone": "Số điện thoại",
      "timezone": "Múi giờ",
      "language": "Ngôn ngữ",
      "save": "Lưu",
      "address": {
        "address": "Địa chỉ",
        "city": "Thành phố/Quận huyện",
        "country": "Quốc gia",
        "countryPlaceholder": "Chọn quốc gia",
        "helper": "Địa chỉ này được dùng cho hoá đơn, yêu cầu thanh toán và các tài liệu liên quan.",
        "state": "Tỉnh/Thành",
        "statePlaceholder": "Chọn tỉnh/thành",
        "title": "Thông tin địa chỉ",
        "zip": "Mã bưu chính",
        "fieldAddress": "Địa chỉ",
        "fieldCity": "Thành phố",
        "fieldZip": "Mã bưu chính",
        "fieldCountry": "Quốc gia",
        "incomplete": "Để lưu địa chỉ, vui lòng điền thêm: {{fields}}."
      },
      "dob": "Ngày sinh",
      "fullName": "Họ và tên",
      "gender": {
        "label": "Giới tính",
        "female": "Nữ",
        "male": "Nam",
        "other": "Khác",
        "preferNot": "Không muốn tiết lộ"
      },
      "phoneDial": "Mã quốc gia",
      "saveChanges": "Lưu thay đổi"
    },
    "general": {
      "title": "Cài đặt tổng quát",
      "billingInfo": "Thông tin xuất hoá đơn",
      "billingInfo.subtitle": "Dùng cho hoá đơn, biên lai và chứng từ thuế.",
      "billingInfo.legalName": "Tên pháp lý",
      "billingInfo.taxId": "Mã số thuế",
      "billingInfo.addressLine1": "Địa chỉ 1",
      "billingInfo.addressLine2": "Địa chỉ 2",
      "billingInfo.city": "Thành phố",
      "billingInfo.state": "Tỉnh / Bang",
      "billingInfo.postalCode": "Mã bưu điện",
      "billingInfo.country": "Quốc gia",
      "billingMode": "Chế độ thanh toán",
      "billingMode.adminControlled": "Chế độ thanh toán do Admin cấu hình. Liên hệ Hỗ trợ nếu cần thay đổi.",
      "billingMode.prepaid.label": "Trả trước",
      "billingMode.prepaid.explain": "Ví trả trước, không xuất hoá đơn cần thanh toán",
      "billingMode.credit.label": "Tín dụng",
      "billingMode.credit.explain": "Trừ vào hạn mức tín dụng",
      "billingMode.invoice.label": "Hoá đơn",
      "billingMode.invoice.explain": "Thanh toán hoá đơn theo lịch",
      "preferences": "Tuỳ chọn",
      "preferences.subtitle": "Giao diện, mật độ và ngôn ngữ hiển thị."
    },
    "preferences": {
      "theme": "Giao diện",
      "theme.light": "Sáng",
      "theme.dark": "Tối",
      "theme.system": "Theo hệ thống",
      "density": "Mật độ",
      "density.compact": "Gọn",
      "density.normal": "Bình thường",
      "currency": {
        "usd": "Đô la Mỹ",
        "vnd": "Đồng Việt Nam",
        "eur": "Euro",
        "gbp": "Bảng Anh",
        "aud": "Đô la Úc",
        "cad": "Đô la Canada",
        "jpy": "Yên Nhật",
        "cny": "Nhân dân tệ"
      }
    },
    "activity": {
      "title": "Hoạt động gần đây",
      "empty": "Chưa có hoạt động.",
      "ipPrefix": "IP:",
      "loadMore": "Tải thêm hoạt động",
      "subtitle": "Hoạt động gần đây và lịch sử đăng nhập của tài khoản"
    },
    "security": {
      "_comment": "Phase 6 Wave 11 Task 36 — Bảo mật (Đổi MK + 2FA + Phiên + Lịch sử). vg-binding: PLAN:task-36 / P6.D-124..130 / G-58 / G-59",
      "title": "Bảo mật",
      "openLink": "Mở",
      "forgotPassword": "Quên mật khẩu?",
      "devices": {
        "title": "Thiết bị và lịch sử"
      },
      "password": {
        "change": "Đổi mật khẩu",
        "current": "Mật khẩu hiện tại",
        "new": "Mật khẩu mới",
        "confirm": "Xác nhận mật khẩu mới",
        "submit": "Cập nhật mật khẩu",
        "tooShort": "Mật khẩu tối thiểu 8 ký tự.",
        "mismatch": "Mật khẩu xác nhận không khớp.",
        "changedRedirect": "Đã đổi mật khẩu. Đang chuyển về trang đăng nhập…",
        "strength": {
          "weak": "Yếu",
          "medium": "Trung bình",
          "strong": "Mạnh"
        },
        "show": "Hiện mật khẩu",
        "hide": "Ẩn mật khẩu",
        "currentWrong": "Mật khẩu hiện tại không đúng.",
        "sameAsCurrent": "Mật khẩu mới không được trùng mật khẩu cũ.",
        "matched": "Mật khẩu khớp.",
        "success": "Đổi mật khẩu thành công. Các phiên khác đã được đăng xuất.",
        "title": "Đổi mật khẩu"
      },
      "2fa": {
        "label": "Xác thực hai bước",
        "subtitle": "Thêm lớp bảo vệ thứ hai (ứng dụng xác thực) cho đăng nhập và giao dịch quan trọng.",
        "enabled": "Đã bật",
        "disabled": "Chưa bật",
        "setup": "Bật xác thực 2 bước",
        "disable": "Tắt xác thực 2 bước",
        "disableConfirm": "Nhập mật khẩu tài khoản để tắt xác thực hai bước.",
        "scanQr": "Quét mã QR bằng ứng dụng xác thực",
        "qrAlt": "Mã QR đăng ký 2FA",
        "manualKey": "Hoặc nhập khóa thủ công",
        "codeLabel": "Mã 6 chữ số từ ứng dụng xác thực",
        "verify": "Xác nhận và bật",
        "enabledSuccess": "Đã bật xác thực hai bước cho tài khoản của bạn.",
        "recoveryCodes": {
          "title": "Mã khôi phục",
          "warn": "Lưu các mã này ngay — chỉ hiển thị một lần duy nhất. Mỗi mã dùng được một lần nếu bạn mất ứng dụng xác thực.",
          "download": "Tải xuống file TXT",
          "unavailable": "Không có mã khôi phục. Liên hệ Hỗ trợ nếu cần cấp lại.",
          "savedAck": "Tôi đã lưu các mã này"
        },
        "qrUnavailable": "Không có mã QR",
        "codePlaceholder": "Nhập mã 6 số từ ứng dụng của bạn",
        "enable": "Bật 2FA",
        "manualCode": "Mã nhập thủ công:",
        "setupHint": "Quét mã QR này bằng ứng dụng xác thực bất kỳ (Google Authenticator, Authy, Microsoft Authenticator, v.v.)",
        "setupTitle": "Thiết lập xác thực hai lớp",
        "tagline": "Thêm một lớp bảo mật cho tài khoản của bạn",
        "verifyEnable": "Xác minh & Bật",
        "codeHint": "Mã đổi 30 giây/lần. Hãy nhập mã đang hiển thị trên Google Authenticator ngay khi bấm Verify (không dùng mã cũ).",
        "passwordLabel": "Mật khẩu tài khoản",
        "passwordTooShort": "Nhập mật khẩu tài khoản (ít nhất 8 ký tự)."
      }
    },
    "sessions": {
      "_comment": "Phase 6 Wave 11 Task 36 — Phiên đăng nhập đang hoạt động. vg-binding: PLAN:task-36 / P6.D-126 / G-58",
      "title": "Phiên đang hoạt động",
      "subtitle": "Các thiết bị đang đăng nhập vào tài khoản của bạn. Thu hồi bất kỳ phiên nào bạn không nhận ra.",
      "current": "Hiện tại",
      "revoke": "Thu hồi",
      "revokeAll": "Thu hồi tất cả phiên khác",
      "revokeAllConfirm": "Đăng xuất khỏi tất cả thiết bị khác? Phiên hiện tại sẽ được giữ lại.",
      "empty": "Không có phiên đang hoạt động.",
      "column": {
        "device": "Thiết bị",
        "ip": "Địa chỉ IP",
        "location": "Vị trí",
        "lastActive": "Hoạt động lần cuối"
      },
      "activeNow": "Đang hoạt động",
      "signOut": "Đăng xuất",
      "signOutAll": "Đăng xuất tất cả phiên khác"
    },
    "loginHistory": {
      "_comment": "Phase 6 Wave 11 Task 36 — Lịch sử đăng nhập. vg-binding: PLAN:task-36 / P6.D-127 / G-58 / G-59",
      "title": "Lịch sử đăng nhập",
      "subtitle": "Các lần đăng nhập gần đây thành công và thất bại trên tài khoản của bạn.",
      "empty": "Không có lần đăng nhập trong khoảng thời gian này.",
      "filter": {
        "from": "Từ",
        "to": "Đến"
      },
      "column": {
        "ts": "Thời điểm",
        "ip": "Địa chỉ IP",
        "location": "Vị trí",
        "device": "Thiết bị",
        "browser": "Trình duyệt",
        "status": "Trạng thái",
        "reason": "Lý do"
      },
      "status": {
        "all": "Tất cả",
        "success": "Thành công",
        "failed": "Thất bại"
      }
    },
    "impersonate": {
      "_comment": "Phase 6 Wave 11 Task 36 — Cảnh báo Admin đang giả lập merchant. vg-binding: PLAN:task-36 / P6.D-128 / P6.D-130",
      "banner": "Bạn đang xem dưới quyền {{merchant}} (Admin {{admin}})",
      "stop": "Dừng giả lập"
    },
    "team": {
      "_comment": "Phase 6 Wave 11 Task 37 — Quản lý thành viên + tạm ngưng/vô hiệu hoá/khôi phục + cấu hình ngân sách. vg-binding: PLAN:task-37 / P6.D-80..D-91 / G-60 / G-61",
      "title": "Thành viên đội ngũ",
      "subtitle": "Mời đồng đội và quản lý quyền truy cập, hạn mức chi tiêu.",
      "create": {
        "label": "Mời thành viên",
        "description": "Tạo lời mời thành viên ở trạng thái chờ với vai trò và hạn mức chi tiêu."
      },
      "empty": "Chưa có thành viên nào.",
      "search": {
        "label": "Tìm kiếm",
        "placeholder": "Tìm theo tên hoặc email…"
      },
      "filter": {
        "allRoles": "Tất cả vai trò",
        "allStatus": "Tất cả trạng thái"
      },
      "footer": {
        "count": "{{count}} thành viên"
      },
      "tab": {
        "profile": "Hồ sơ",
        "permissions": "Phân quyền",
        "budget": "Ngân sách",
        "activity": "Hoạt động"
      },
      "role": {
        "admin": "Quản trị",
        "admin.desc": "Toàn quyền — thanh toán, đội ngũ, mọi cài đặt.",
        "manager": "Quản lý",
        "manager.desc": "Vận hành + tài chính, không truy cập cài đặt đội/thanh toán.",
        "staff": "Nhân viên",
        "staff.desc": "Xử lý đơn + sản phẩm hàng ngày, tài chính giới hạn.",
        "viewer": "Người xem",
        "viewer.desc": "Chỉ xem — bảng điều khiển, đơn hàng và báo cáo."
      },
      "status": {
        "active": "Hoạt động",
        "suspended": "Tạm ngưng",
        "deactivated": "Đã vô hiệu",
        "pending": "Chờ kích hoạt"
      },
      "column": {
        "avatar": "Ảnh đại diện",
        "name": "Thành viên",
        "email": "Email",
        "role": "Vai trò",
        "status": "Trạng thái",
        "lastLogin": "Lần đăng nhập gần nhất",
        "budget": "Ngân sách",
        "orderLimit": "Hạn mức đơn",
        "actions": "Thao tác"
      },
      "form": {
        "field": {
          "name": "Tên hiển thị",
          "email": "Email",
          "role": "Vai trò",
          "monthlyBudget": "Ngân sách tháng (USD)",
          "orderLimit": "Hạn mức mỗi đơn (USD)",
          "sendInvite": "Gửi email kích hoạt ngay"
        },
        "budget": {
          "help": "Giới hạn chi tháng của thành viên (USD). Để trống = không giới hạn."
        }
      },
      "action": {
        "suspend": {
          "title": "Tạm ngưng tài khoản",
          "warn": "Người dùng không thể đăng nhập trong khi bị tạm ngưng. Có thể khôi phục bất cứ lúc nào.",
          "description": "Xác nhận tạm ngưng có thể khôi phục và ghi lý do kiểm toán."
        },
        "deactivate": {
          "title": "Vô hiệu hoá vĩnh viễn",
          "warn": "Hành động này KHÔNG thể hoàn tác. Tất cả phiên đăng nhập sẽ bị thu hồi.",
          "typeConfirm": "Gõ 'deactivate' để xác nhận",
          "description": "Xác nhận vô hiệu hoá vĩnh viễn, lý do kiểm toán và thu hồi phiên."
        },
        "reactivate": "Khôi phục",
        "resendInvite": "Gửi lại lời mời"
      },
      "reason": {
        "label": "Lý do (bắt buộc)"
      },
      "activity": {
        "placeholder": "Nhật ký hoạt động theo từng thành viên sẽ ra mắt ở wave sau. Xem Cài đặt → Hoạt động cho dòng thời gian toàn tài khoản."
      },
      "create.success": "Đã gửi lời mời tới {{email}}.",
      "update.success": "Đã cập nhật thành viên.",
      "suspend.success": "Đã tạm ngưng thành viên.",
      "deactivate.success": "Đã vô hiệu hoá thành viên.",
      "reactivate.success": "Đã khôi phục thành viên.",
      "resendInvite.success": "Đã gửi lại lời mời.",
      "detail": {
        "description": "Chỉnh sửa hồ sơ thành viên, vai trò, hạn mức chi tiêu và chi tiết hoạt động."
      }
    },
    "notifications": {
      "toggleAria": "{{cat}} {{ch}}"
    },
    "account": {
      "subtitle": "Quản lý hồ sơ, bảo mật, thông báo và tùy chọn của bạn",
      "title": "Cài đặt tài khoản"
    },
    "pref": {
      "appearance": "Giao diện",
      "communication": {
        "label": "Cài đặt liên lạc",
        "sub": "Cách và thời điểm chúng tôi gửi email cho bạn."
      },
      "currency": "Tiền tệ",
      "dashboardView": {
        "label": "Chế độ xem Dashboard mặc định",
        "compact": "Gọn",
        "expanded": "Mở rộng (Nhiều chi tiết hơn)",
        "help": "Cách bảng dữ liệu hiển thị mặc định"
      },
      "dateFormat": "Định dạng ngày",
      "display": {
        "label": "Cài đặt hiển thị",
        "sub": "Giao diện và bố cục dashboard mặc định."
      },
      "emailDigest": {
        "label": "Bản tóm tắt qua email",
        "daily": "Hàng ngày",
        "help": "Bản tóm tắt hoạt động gửi tới email của bạn",
        "monthly": "Hàng tháng",
        "none": "Không",
        "weekly": "Tóm tắt hàng tuần"
      },
      "regional": {
        "label": "Cài đặt khu vực",
        "sub": "Tiền tệ và định dạng ngày dùng trong toàn ứng dụng."
      },
      "save": "Lưu thay đổi"
    }
  },
  "branding": {
    "_comment": "Phase 6 Wave 11 Task 38 — Cài đặt thương hiệu (4 tab) + nhật ký thay đổi. vg-binding: PLAN:task-38 / P6.D-100 / P6.D-101 / P6.D-105 / G-62 | Task 39 — gift-messages + thank-you-cards (P6.D-102 / P6.D-103 / G-64)",
    "title": "Thương hiệu",
    "openEditor": "Mở trình chỉnh sửa đầy đủ",
    "tab": {
      "brandIdentity": "Nhận diện thương hiệu",
      "thankYouCards": "Thiệp cảm ơn",
      "thankYouCards.description": "Thiết kế thiệp cảm ơn in kèm trong đơn hàng của khách. Trình chỉnh sửa đầy đủ nằm ở trang Thiệp cảm ơn.",
      "giftMessages": "Lời nhắn tặng",
      "giftMessages.description": "Quản lý mẫu lời nhắn tặng cho merchant và khách hàng dùng khi đặt hàng. Trình chỉnh sửa đầy đủ nằm ở trang Lời nhắn tặng.",
      "packaging": "Bao bì"
    },
    "identity": {
      "title": "Nhận diện thương hiệu",
      "subtitle": "Logo, màu sắc và slogan hiển thị trên biên lai, hoá đơn và bao bì.",
      "brandName": "Tên thương hiệu",
      "logo": "Logo",
      "uploadLogo": "Tải logo",
      "primaryColor": "Màu chính",
      "secondaryColor": "Màu phụ",
      "fontFamily": "Phông chữ",
      "tagline": "Slogan",
      "taglinePlaceholder": "Slogan ngắn cho biên lai và bao bì",
      "save": "Lưu",
      "preview": "Xem trước",
      "previewBadge": "Huy hiệu mẫu"
    },
    "packaging": {
      "title": "Bao bì mặc định",
      "description": "Chọn loại bao bì áp dụng mặc định cho mọi đơn hàng. Admin quản lý danh mục.",
      "defaultLabel": "Mặc định",
      "setDefault": "Đặt làm mặc định",
      "empty": "Chưa có loại bao bì nào."
    },
    "changelog": {
      "title": "Thay đổi gần đây",
      "empty": "Chưa có thay đổi nào.",
      "entry": "{{actor}} đã đổi {{field}} từ {{oldValue}} thành {{newValue}}"
    },
    "giftMessages": {
      "title": "Lời nhắn tặng",
      "create": "Tạo mới",
      "submit": "Lưu lời nhắn",
      "preview": "Xem trước",
      "previewPlaceholder": "Lời nhắn của bạn sẽ hiển thị ở đây.",
      "savedToast": "Đã lưu lời nhắn tặng.",
      "empty": "Chưa có mẫu lời nhắn nào. Tạo mẫu để áp dụng khi đặt hàng.",
      "field": {
        "title": "Tiêu đề",
        "occasion": "Dịp",
        "message": "Nội dung",
        "language": "Ngôn ngữ",
        "isDefault": "Mặc định",
        "charCounter": "{{count}} / {{max}}"
      },
      "occasion": {
        "birthday": "Sinh nhật",
        "holiday": "Lễ",
        "anniversary": "Kỷ niệm",
        "thankYou": "Cảm ơn",
        "custom": "Khác"
      },
      "backToSettings": "Quay lại cài đặt Branding",
      "edit": "Sửa lời nhắn quà tặng",
      "editNotFound": "Không tìm thấy lời nhắn quà tặng.",
      "noResults": "Không có lời nhắn nào khớp tìm kiếm.",
      "resultsCount": "{{count}} kết quả",
      "searchPlaceholder": "Tìm lời nhắn quà tặng…"
    },
    "thankYouCards": {
      "title": "Thiệp cảm ơn",
      "create": "Tạo mới",
      "submit": "Lưu thiệp",
      "preview": "Xem trước trực tiếp",
      "previewPlaceholder": "Lời nhắn hiển thị ở đây.",
      "savedToast": "Đã lưu thiệp cảm ơn.",
      "empty": "Chưa có thiệp nào. Tạo mới hoặc chọn mẫu phía dưới.",
      "imageHint": "PNG / JPG, ≤ 5 MB",
      "field": {
        "title": "Tiêu đề",
        "header": "Dòng tiêu đề",
        "body": "Nội dung",
        "footer": "Dòng chân",
        "fontFamily": "Phông chữ",
        "accentColor": "Màu nhấn",
        "image": "Hình ảnh (tuỳ chọn)",
        "isDefault": "Mặc định"
      },
      "templates": {
        "title": "Bắt đầu từ mẫu",
        "useThis": "Dùng mẫu này",
        "empty": "Chưa có mẫu nào.",
        "prefilled": "Đã điền từ mẫu."
      },
      "backToSettings": "Quay lại cài đặt Branding",
      "edit": "Sửa thiệp cảm ơn",
      "editNotFound": "Không tìm thấy thiệp cảm ơn.",
      "imageTooLarge": "Ảnh phải nhỏ hơn hoặc bằng 8 MB.",
      "noResults": "Không có thiệp nào khớp tìm kiếm.",
      "resultsCount": "{{count}} kết quả",
      "searchPlaceholder": "Tìm thiệp…"
    },
    "logoAlt": {
      "logo": "Logo thương hiệu",
      "preview": "Xem trước logo thương hiệu"
    }
  },
  "notifications": {
    "_comment": "Phase 6 Wave 11 Task 38 — Tuỳ chọn thông báo (7 nhóm × 3 kênh + âm thanh). Phase 6 Wave 12 Task 40 — bổ sung Trung tâm thông báo (6 tab / nhóm theo ngày / trống / cài đặt / huy hiệu chưa đọc realtime). vg-binding: PLAN:task-38 / PLAN:task-40 / P6.D-06 / P6.D-118 / P6.D-119 / P6.D-120 / P6.D-121 / P6.D-174 / P6.D-225 / G-63 / G-65 / G-66",
    "title": "Tuỳ chọn thông báo",
    "save": "Lưu cài đặt",
    "loadMore": "Tải thêm",
    "unread": "Chưa đọc",
    "nav": {
      "label": "Thông báo"
    },
    "center": {
      "title": "Trung tâm thông báo"
    },
    "settings": {
      "title": "Cài đặt thông báo",
      "category": {
        "orders": "Đơn hàng",
        "shipping": "Vận chuyển",
        "payment": "Thanh toán",
        "wallet": "Ví",
        "billing": "Hoá đơn",
        "system": "Thông báo hệ thống",
        "marketing": "Khuyến mãi"
      }
    },
    "tab": {
      "all": "Tất cả",
      "orders": "Đơn hàng",
      "products": "Sản phẩm",
      "stores": "Cửa hàng",
      "wallet": "Ví",
      "system": "Hệ thống",
      "billing": "Hoá đơn"
    },
    "filter": {
      "unreadOnly": "Chỉ chưa đọc"
    },
    "bulk": {
      "markAllRead": "Đánh dấu tất cả đã đọc",
      "markAllReadError": "Không thể đánh dấu tất cả đã đọc. Vui lòng thử lại."
    },
    "item": {
      "viewDetail": "Xem chi tiết"
    },
    "empty": {
      "title": "Chưa có thông báo nào",
      "subtitle": "Khi có thông báo mới về đơn hàng, ví hoặc cửa hàng, bạn sẽ thấy ở đây."
    },
    "group": {
      "today": "Hôm nay",
      "yesterday": "Hôm qua",
      "earlier": "Trước đó"
    },
    "column": {
      "category": "Nhóm thông báo"
    },
    "category": {
      "orders": "Đơn hàng",
      "shipping": "Vận chuyển",
      "payment": "Thanh toán",
      "wallet": "Ví",
      "billing": "Hoá đơn",
      "system": "Thông báo hệ thống",
      "marketing": "Khuyến mãi"
    },
    "channel": {
      "email": "Email",
      "push": "Push",
      "inApp": "Trong ứng dụng"
    },
    "sound": {
      "label": "Âm thanh thông báo trong ứng dụng",
      "help": "Phát một tiếng chuông ngắn khi có thông báo mới.",
      "on": "Bật",
      "off": "Tắt"
    },
    "detail": {
      "notFound": "Không tìm thấy thông báo.",
      "back": "Về danh sách thông báo",
      "emptyBody": "Không có nội dung chi tiết."
    }
  },
  "dashboard": {
    "_comment": "Phase 6 Wave 12 Task 41 — Dashboard surface (KPI strip + Getting Started + Quick Actions + Recent Orders + Top Products + Activity Feed + Growth placeholder + 5-step Onboarding wizard). vg-binding: PLAN:task-41 / P6.D-07..14 / G-67 / G-68",
    "title": "Bảng điều khiển",
    "kpi": {
      "todayRevenue": "Doanh thu hôm nay",
      "activeOrders": "Đơn đang xử lý",
      "walletBalance": "Số dư ví",
      "pendingTopups": "Nạp tiền chờ duyệt",
      "deltaUp": "tăng",
      "deltaDown": "giảm"
    },
    "gettingStarted": {
      "title": "Bắt đầu nhanh",
      "progress": "Hoàn tất {{pct}}%",
      "hideForever": "Ẩn vĩnh viễn",
      "step": {
        "connectStore": "Kết nối cửa hàng đầu tiên",
        "addProduct": "Thêm sản phẩm đầu tiên",
        "branding": "Cấu hình thương hiệu",
        "setup2fa": "Cài đặt xác thực hai yếu tố",
        "topupWallet": "Nạp tiền vào ví",
        "inviteTeam": "Mời thành viên nhóm",
        "setupNotifications": "Cài đặt thông báo",
        "firstOrder": "Tạo đơn hàng đầu tiên"
      }
    },
    "quickActions": {
      "title": "Thao tác nhanh",
      "action": {
        "createOrder": "Tạo đơn",
        "createOrder.subtext": "Đơn mới hoặc nhập từ Excel",
        "connectStore": "Kết nối cửa hàng",
        "connectStore.subtext": "Shopify, Woo, TikTok",
        "topupWallet": "Nạp tiền",
        "topupWallet.subtext": "Bổ sung quỹ xử lý đơn",
        "viewReports": "Xem báo cáo",
        "viewReports.subtext": "Thanh toán & hoá đơn"
      }
    },
    "recentOrders": {
      "title": "Đơn hàng gần đây",
      "empty": "Chưa có đơn nào — đơn đầu tiên sẽ hiển thị tại đây.",
      "status": {
        "draft": "Nháp",
        "pending": "Chờ xử lý",
        "processing": "Đang xử lý",
        "shipped": "Đang giao",
        "delivered": "Đã giao",
        "cancelled": "Đã huỷ",
        "issues": "Có vấn đề"
      }
    },
    "topProducts": {
      "title": "Sản phẩm bán chạy",
      "unitsSold": "sp",
      "empty": "Chưa có doanh số trong 30 ngày qua.",
      "viewAll": "Xem tất cả"
    },
    "activityFeed": {
      "title": "Hoạt động gần đây",
      "empty": "Chưa có hoạt động nào."
    },
    "growth": {
      "placeholder": {
        "badge": "Dữ liệu mẫu",
        "title": "Phân tích tăng trưởng sắp ra mắt",
        "cta": "GMV, hạng thành viên và chiến dịch sẽ hiển thị tại đây trong Phase 10."
      }
    },
    "onboarding": {
      "welcome": {
        "title": "Chào mừng đến với Printway",
        "subtitle": "Quy trình thiết lập 5 bước nhanh chóng để bắt đầu."
      },
      "step": {
        "businessType": "Chọn loại hình kinh doanh",
        "connectStore": "Kết nối cửa hàng đầu tiên",
        "addProduct": "Thêm sản phẩm đầu tiên",
        "done": "Hoàn tất"
      },
      "businessType": {
        "pod": "In theo yêu cầu (POD)",
        "pod.subtext": "Bán quần áo, cốc, phụ kiện in tuỳ chỉnh.",
        "general": "Cửa hàng tổng hợp",
        "general.subtext": "Danh mục sản phẩm đa dạng."
      },
      "connectStore": {
        "subtitle": "Kết nối Shopify, WooCommerce hoặc TikTok Shop trong một bước.",
        "cta": "Mở trình kết nối"
      },
      "addProduct": {
        "subtitle": "Duyệt catalog và tạo sản phẩm đầu tiên của bạn.",
        "cta": "Mở wizard sản phẩm"
      },
      "done": {
        "subtitle": "Mọi thứ đã sẵn sàng — chuyển bạn đến bảng điều khiển."
      },
      "next": "Tiếp",
      "back": "Quay lại",
      "skip": "Bỏ qua",
      "complete": "Vào bảng điều khiển"
    },
    "subtitle": "Đây là tình hình kinh doanh print-on-demand của bạn.",
    "welcome": "Chào mừng trở lại!",
    "welcomeNamed": "Chào mừng trở lại, {{name}}!"
  },
  "myProducts": {
    "columns": {
      "thumbnail": "Ảnh",
      "name": "Tên",
      "category": "Danh mục",
      "sync": "Đồng bộ",
      "created": "Tạo lúc",
      "lastModified": "Sửa lúc",
      "actions": "Hành động"
    },
    "delete": {
      "success": "Đã xoá \"{{name}}\"",
      "failed": "Xoá thất bại"
    }
  },
  "a11y": {
    "_comment": "Phase 6 i18n batch M3 — aria-label sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "pagination": "Phân trang",
    "firstPage": "Trang đầu",
    "previousPage": "Trang trước",
    "nextPage": "Trang sau",
    "lastPage": "Trang cuối",
    "openProfileMenu": "Mở menu hồ sơ",
    "loadingPage": "Đang tải trang",
    "promoBanner": "Banner khuyến mãi",
    "dismissPromoBanner": "Đóng banner khuyến mãi",
    "expandSidebar": "Mở rộng thanh điều hướng",
    "collapseSidebar": "Thu gọn thanh điều hướng",
    "dismissNotification": "Đóng thông báo",
    "productEditorTabs": "Tab chỉnh sửa sản phẩm",
    "close": "Đóng",
    "storeDisconnected": "Chưa kết nối cửa hàng",
    "storeSyncStatus": "Trạng thái đồng bộ theo cửa hàng",
    "bulkActions": "Hành động hàng loạt",
    "moveUp": "Chuyển lên",
    "moveDown": "Chuyển xuống",
    "remove": "Xóa",
    "breadcrumb": "Đường dẫn",
    "primaryNavigation": "Điều hướng chính",
    "openNavigation": "Mở thanh điều hướng",
    "artworkGrid": "Lưới thiết kế",
    "clear": "Xóa",
    "clearSearch": "Xóa tìm kiếm",
    "removeLine": "Xoá dòng",
    "statementsChart": "Biểu đồ sao kê",
    "spendingChart": "Biểu đồ chi tiêu",
    "range": "Khoảng thời gian",
    "primaryColorHex": "Mã hex màu chính",
    "secondaryColorHex": "Mã hex màu phụ",
    "onboardingProgress": "Tiến trình thiết lập",
    "orderDetailSections": "Các mục chi tiết đơn hàng",
    "public": "Công khai",
    "private": "Riêng tư",
    "removeRule": "Xoá điều kiện",
    "orderStatusTabs": "Tab trạng thái đơn hàng",
    "required": "Bắt buộc",
    "decreaseQuantity": "Giảm số lượng",
    "increaseQuantity": "Tăng số lượng",
    "decrease": "Giảm",
    "increase": "Tăng",
    "settingsSections": "Các mục cài đặt",
    "teamMemberDetailTabs": "Tab chi tiết thành viên",
    "walletSubNavigation": "Điều hướng phụ của ví",
    "instantGateways": "Cổng nạp tức thì",
    "selectAllRows": "Chọn tất cả dòng",
    "selectRow": "Chọn dòng {{id}}",
    "skipToMain": "Bỏ qua tới nội dung chính",
    "backToTop": "Lên đầu trang",
    "openHelpMenu": "Mở menu trợ giúp"
  },
  "placeholder": {
    "_comment": "Phase 6 i18n batch M3 — placeholder sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "url": "https://…",
    "productSlug": "my-awesome-product",
    "sku": "SKU…",
    "storeIds": "store_1, store_2",
    "categoryIds": "apparel, drinkware",
    "emailExample": "email@example.com",
    "expDate": "MM/YY",
    "cardHolderName": "Nguyễn Văn A",
    "fnsku": "X00ABCDEFG",
    "countryCode": "VN",
    "skuPrefix": "SKU-",
    "timezone": "UTC",
    "shopifyDomain": "your-shop.myshopify.com",
    "shopUrl": "https://shop.example.com",
    "merchantEmail": "merchant@example.com",
    "opsEmail": "ops@example.com"
  },
  "placeholders": {
    "_comment": "Phase 6 i18n batch M4 — PlaceholderPage stub titles. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "_fallback": {
      "title": "...",
      "description": "Trang giữ chỗ — phần này sẽ ra mắt ở các wave sau."
    },
    "dashboard": {
      "title": "Bảng điều khiển"
    },
    "artworkLibrary": {
      "title": "Thư viện thiết kế"
    },
    "invoiceDetail": {
      "title": "Chi tiết hóa đơn"
    },
    "invoices": {
      "title": "Hóa đơn"
    },
    "notifications": {
      "title": "Thông báo"
    },
    "onboarding": {
      "title": "Thiết lập ban đầu"
    },
    "orderCreate": {
      "title": "Tạo đơn hàng"
    },
    "orderDetail": {
      "title": "Chi tiết đơn hàng"
    },
    "orderImport": {
      "title": "Nhập đơn hàng"
    },
    "orders": {
      "title": "Đơn hàng"
    },
    "productCreate": {
      "title": "Tạo sản phẩm"
    },
    "productDetail": {
      "title": "Chi tiết sản phẩm"
    },
    "settingsBranding": {
      "title": "Thương hiệu"
    },
    "settingsProfile": {
      "title": "Hồ sơ"
    },
    "storeDetail": {
      "title": "Chi tiết cửa hàng"
    },
    "stores": {
      "title": "Cài đặt cửa hàng"
    },
    "storesSyncLogs": {
      "title": "Nhật ký đồng bộ"
    },
    "support": {
      "title": "Hỗ trợ"
    },
    "team": {
      "title": "Nhân sự"
    },
    "wallet": {
      "title": "Ví"
    },
    "walletTopup": {
      "title": "Nạp tiền vào ví"
    },
    "walletTransactions": {
      "title": "Lịch sử giao dịch ví"
    }
  },
  "search": {
    "placeholder": "Tìm…",
    "empty": "Không có kết quả",
    "moreHint": "+{{count}} nữa — gõ để tìm"
  },
  "profile": {
    "guest": "Khách",
    "account": "Tài khoản",
    "notSignedIn": "Chưa đăng nhập"
  },
  "breadcrumb": {
    "import": "Nhập",
    "artwork": "Thư viện thiết kế",
    "topup": "Nạp tiền",
    "transactions": "Giao dịch",
    "onboarding": "Hướng dẫn bắt đầu",
    "login": "Đăng nhập",
    "home": "Trang chủ",
    "detail": "Chi tiết",
    "paymentMethods": "Phương thức thanh toán",
    "paymentRequests": "Yêu cầu thanh toán",
    "backToBilling": "← Quay lại Thanh toán"
  },
  "bulkUpload": {
    "errorMalformedResponse": "Phản hồi tải lên không hợp lệ — xem nhật ký mạng.",
    "errorHttpStatus": "Tải lên thất bại (HTTP {{status}})",
    "dropPrompt": "Kéo CSV vào đây, hoặc",
    "browseFile": "chọn tệp",
    "selectedLabel": "Đã chọn:",
    "uploading": "Đang tải lên…",
    "upload": "Tải lên",
    "successCount": "{{n}} thành công",
    "failureCount": "{{n}} lỗi",
    "totalRows": "trong {{total}} dòng",
    "viewErrorDetails": "Xem chi tiết lỗi ({{n}})",
    "rowLabel": "Dòng {{row_num}}"
  },
  "timezone": {
    "autoDetect": "Tự động phát hiện ({{tz}})"
  },
  "common": {
    "loading": "Đang tải…",
    "cancel": "Huỷ",
    "close": "Đóng",
    "pagination": {
      "pageOf": "Trang {{page}} / {{total}}"
    }
  },
  "badge": {
    "featured": "Nổi bật"
  },
  "detail": {
    "blueprint": "Blueprint",
    "metaDescription": "Mô tả meta",
    "metaTitle": "Tiêu đề meta",
    "seo": "SEO",
    "size": "Kích thước",
    "edit": "Chỉnh sửa",
    "media": "Hình ảnh",
    "noImage": "Chưa có ảnh",
    "primary": "Chính",
    "general": "Thông tin chung",
    "category": "Danh mục",
    "blueprintVersion": "Phiên bản blueprint",
    "createdAt": "Tạo lúc",
    "updatedAt": "Cập nhật lúc",
    "tags": "Thẻ",
    "variants": "Biến thể",
    "color": "Màu",
    "priceOverride": "Giá riêng",
    "inventory": "Tồn kho",
    "state": "Trạng thái",
    "retired": "Đã ẩn",
    "activeVariant": "Đang bán",
    "pricingPerStore": "Giá bán theo cửa hàng",
    "store": "Cửa hàng",
    "sellingPrice": "Giá bán",
    "baseCost": "Giá cost (hệ thống → merchant)"
  },
  "help": {
    "announcements": "Thông báo",
    "contact": "Liên hệ hỗ trợ",
    "docs": "Tài liệu"
  },
  "notif": {
    "email": {
      "master": "Bật thông báo qua email",
      "test": "Kiểm tra",
      "testSent": "Đã gửi",
      "title": "Thông báo Email"
    },
    "inApp": {
      "days": "{{count}} ngày",
      "retention": "Giữ thông báo trong:",
      "sound": "Bật âm thanh thông báo",
      "soundHelp": "Phát một tiếng chuông ngắn khi có thông báo mới.",
      "title": "Thông báo trong ứng dụng"
    },
    "notVerified": "Chưa xác minh",
    "push": {
      "blocked": "Đã chặn",
      "deniedHelp": "Push bị chặn trong cài đặt trình duyệt. Hãy bật lại ở đó trước.",
      "enabled": "Đã bật",
      "help": "Hiện cảnh báo trên màn hình ngay cả khi tab này chạy nền.",
      "master": "Bật thông báo đẩy trên trình duyệt",
      "notRequested": "Chưa yêu cầu",
      "title": "Thông báo đẩy",
      "unsupported": "Không hỗ trợ",
      "unsupportedHelp": "Trình duyệt của bạn không hỗ trợ thông báo đẩy.",
      "inactive": "Chưa bật trên thiết bị này",
      "activeHelp": "Trình duyệt này sẽ nhận cảnh báo ví kể cả khi tab đang ở nền.",
      "unconfigured": "Máy chủ chưa cấu hình push.",
      "error": "Không cập nhật được cài đặt push. Vui lòng thử lại.",
      "working": "Đang cập nhật…"
    },
    "quiet": {
      "end": "Kết thúc",
      "master": "Bật giờ im lặng (không thông báo trong khoảng này)",
      "start": "Bắt đầu",
      "title": "Giờ im lặng"
    },
    "sms": {
      "codeLabel": "Nhập mã 6 số chúng tôi đã gửi cho bạn",
      "help": "Xác minh số điện thoại để nhận thông báo qua SMS.",
      "invalidCode": "Mã không hợp lệ.",
      "master": "Bật thông báo SMS",
      "title": "Thông báo SMS",
      "verifyCode": "Xác minh",
      "verifyPhone": "Xác minh số điện thoại"
    },
    "verified": "Đã xác minh"
  },
  "pagination": {
    "of": "trên",
    "rowsPerPage": "Số dòng mỗi trang",
    "showing": "Đang hiện"
  },
  "shipments": {
    "trackRouting": {
      "alerts": {
        "ageDays": "+{{days}} ngày",
        "collapse": "Thu gọn cảnh báo",
        "empty": "Không có cảnh báo.",
        "expand": "Mở rộng cảnh báo",
        "openExternal": "Mở chi tiết",
        "summary": "{{critical}} nghiêm trọng, {{warnings}} cảnh báo",
        "title": "Cảnh báo vận chuyển",
        "view": "Xem"
      },
      "cards": {
        "on_time_rate": {
          "sub": "{{numerator}} / {{denominator}} kiện hàng"
        },
        "active_time": {
          "label": "Thời gian hoạt động",
          "sub": "{{count}} kiện hàng · TB {{avgHrs}} · tối đa {{maxHrs}}"
        },
        "last_mile_time": {
          "label": "Thời gian chặng cuối",
          "sub": "{{count}} kiện hàng · TB {{avgHrs}} · tối đa {{maxHrs}}"
        }
      },
      "dashboardTitle": "Bảng hiệu suất SLA",
      "pagination": {
        "next": "Trang sau",
        "prev": "Trang trước",
        "show": "Hiện",
        "total": "Tổng: {{total}}"
      },
      "statusOverview": {
        "title": "Tổng quan trạng thái vận chuyển"
      },
      "subtitle": "Theo dõi hiệu suất SLA và mọi kiện hàng",
      "table": {
        "columns": {
          "firstScan": "Quét đầu tiên",
          "delivered": "Đã giao"
        },
        "delayDays": "+{{days}} ngày trễ",
        "deliveredPrefix": "Đã giao",
        "empty": "Không có kiện hàng nào khớp bộ lọc hiện tại.",
        "openExternal": "Mở link theo dõi",
        "slaDays": "{{days}} ngày",
        "viewAction": "Xem chi tiết",
        "notShipped": "—"
      },
      "title": "Theo dõi định tuyến",
      "toolbar": {
        "allCarriers": "Tất cả đơn vị vận chuyển",
        "allStatuses": "Tất cả trạng thái",
        "searchPlaceholder": "Tìm theo mã vận đơn hoặc đơn hàng…"
      },
      "window": {
        "7d": "7 ngày",
        "30d": "30 ngày",
        "90d": "90 ngày",
        "aria": "Khoảng thời gian số liệu SLA"
      },
      "dashboardEmpty": "Không có dữ liệu trong khoảng này",
      "emptyBanner": {
        "title": "Chưa có dữ liệu theo dõi SLA",
        "description": "Số liệu thời gian SLA sẽ xuất hiện khi đơn vị vận chuyển báo cáo quét kiện hàng trong khoảng thời gian này."
      }
    }
  },
  "sidebar": {
    "categories": "Danh mục",
    "filters": "Bộ lọc",
    "max": "Tối đa",
    "min": "Tối thiểu",
    "priceRange": "Khoảng giá"
  },
  "twoFA": {
    "challengeSubtitle": "Nhập mã 6 số từ ứng dụng xác thực để cho phép hành động này.",
    "challengeTitle": "Xác nhận bằng xác thực hai lớp",
    "code": "Mã 6 số",
    "codeFormat": "Nhập mã 6 số từ ứng dụng xác thực của bạn.",
    "codeLabel": "Mã 6 số",
    "confirm": "Xác nhận",
    "error": "Mã không hợp lệ",
    "errorLength": "Mã phải gồm đúng 6 số",
    "locked": "2FA tạm khoá sau quá nhiều lần thử sai. Vui lòng thử lại sau.",
    "title": "Xác minh 2FA",
    "verify": "Xác minh",
    "notEnrolledTitle": "2FA chưa được bật",
    "notEnrolledDesc": "Withdraw yêu cầu xác thực 2 lớp. Vui lòng bật 2FA trước.",
    "goToSetup": "Đi tới cài đặt bảo mật →"
  },
  "wizard": {
    "breadcrumbEdit": "Sản phẩm của tôi / Sửa sản phẩm",
    "pageTitleEdit": "Sửa sản phẩm",
    "step2": {
      "col": {
        "customSku": "Custom SKU"
      },
      "customSkuHint": "Tùy chọn. Để trống để dùng lại SKU hệ thống khi khớp đơn.",
      "customSkuDup": "Custom SKU bị trùng — phải là duy nhất trong sản phẩm."
    },
    "step3": {
      "libraryEmpty": "Thư viện của bạn trống.",
      "libraryEmptyHint": "Tải file lên qua khu vực kéo-thả bên dưới — file sẽ xuất hiện ở đây lần sau.",
      "libraryLoadFailed": "Không tải được thư viện. Vui lòng thử lại.",
      "libraryTitle": "Chọn từ thư viện"
    },
    "step5": {
      "cards": {
        "mainMissing": "chưa chọn",
        "mainSet": "đã chọn",
        "mockup": "Mockup",
        "mockupCount": "{{count}} ảnh · ảnh chính {{main}}",
        "mockupEmpty": "Chưa tải ảnh nào lên"
      }
    },
    "nav": {
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi"
    }
  },
  "mode": "chỉnh sửa",
  "step": "biến thể",
  "retry": "1",
  "read": "chưa đọc",
  "limit": "20",
  "editor": {
    "actions": {
      "saved": "Đã lưu sản phẩm",
      "saveFailed": "Lưu thất bại",
      "noChanges": "Không có thay đổi để lưu"
    }
  },
  "info": "Đã chuyển artwork vào {{folder}}",
  "error": "Không thể chuyển artwork. Hãy thử lại."
}
